import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { select } from "redux-saga/effects";
import { search } from "./services/receiptNoteService";
import { update } from "lodash";
import { date } from "yup";

const resources = {
  fr: {
    translation: {
      // ...existing code...
      receipt: {
        title: "REÇU DE VENTE",
        store: "Supermarché 123",
        tel: "Tél: 123-456-7890",
        receiptNo: "Reçu N°",
        date: "Date",
        cashier: "Caissier",
        item: "Article",
        quantity: "Qté",
        price: "Prix",
        total: "Total",
        print: "Imprimer PDF",
        close: "Fermer",
        printBill: "Imprimer le ticket",
      },
      product: {
        purchasePriceHT: "Prix d'achat HT",
        purchasePriceTTC: "Prix d'achat TTC",
        noSupplierPrices: "Aucun prix fournisseur",
        supplierPrices: "Prix Fournisseur",
        chooseProduct: "Choisir un produit",
        totalItems: "Total articles",
        editArticle: "Modifier l'article",
        stockPhysique: "Stock Physique",
        stockMinimum: "Stock Minimum",
        stockReserve: "Stock Réservé",
        stockDisponible: "Stock Disponible",
        newArticle: "Nouvel Article",
        salePrice3: "Prix de vente 3",
        salePrice2: "Prix de vente 2",
        salePrice1: "Prix de vente 1",
        isTaxable: "Soumis à la TVA",
        nature: "Nature",
        selectNature: "Sélectionner la nature",
        taxRate: "Taux de TVA",
        imageSizeLimitMessage: "La taille de l'image ne doit pas dépasser 2 Mo",
        imageSizeError: "La taille de l'image est trop grande",
        quantity: "Quantité",
        createNew: "Ajouter un produit",
        new: "Nouveau",
        noProducts: 'Aucun produit trouvé',
        pageTitle: "Gestion des Produits",
        searchPlaceholder: "Rechercher des produits...",
        code: "Code Produit",
        description: "Description",
        barcode: "Code-barres",
        addSuccess: "Produit ajouté avec succès",
        stockQty: "Quantité en Stock",
        salePrice: "P.U (Détail)",
        salePrice2:"P.U. (Gros)",
        buyingPrice: "Prix d'Achat",
        downloadTemplate: "Télécharger Modèle",
        uploadProducts: "Importer Produits",
        uploadSuccess: "Produits importés avec succès",
        uploadError: "Erreur lors de l'importation",
        edit: "Modifier le produit",
        deleteConfirmTitle: "Supprimer le produit?",
        deleteConfirmText: "Cette action ne peut pas être annulée",
        deleted: "Produit supprimé",
        updated: "Produit mis à jour",
        showing: "Affichage de {{start}} à {{end}} sur {{total}} résultats (page {{currentPage}} de {{totalPages}})",
        scanSearch: 'Rechercher ou scanner un code-barres...',
        scanHint: 'Vous pouvez scanner un code-barres pour rechercher rapidement',
        searchFocusHint: "F2 pour rechercher ou scanner...",
        searchShortcut: "Appuyez sur F2 pour rechercher rapidement",
        confirmUpdatePrice: "Confirmer la modification du prix",
        confirmUpdatePriceMessage: "Voulez-vous modifier le prix de vente de ce produit ?",
        priceUpdated: "Prix mis à jour avec succès",
        lastUpdated: "Dernière mise à jour",
        exportSuccessTitle: "Exportation réussie",
        exportSuccessText: "Les produits ont été exportés avec succès",
        exportErrorTitle: "Erreur d'exportation",
        exportErrorText: "Une erreur est survenue lors de l'exportation des produits",
        exportLoading: "Exportation en cours...",
        exportWait: "Veuillez patienter pendant l'exportation des produits",
        image: "Image",
        duplicateBarcode: "Code-barres en double",
        barcodeExistsFor: "Ce code-barres existe déjà pour le produit: {{product}}",
        deleteError: "Erreur de suppression",
        deleteErrorMessage: "Une erreur est survenue lors de la suppression du produit",

      },
      "reglement": {
        allocations:"Affectations des paiements",
        
        syncSuccess:"Opération réussi",
        generateReceipt:"Reçu de paiement",
        receiptTitle:"Reçu de paiement",
        "paymentState": "État du paiement",
        confirmSyncC:"Régler la situation des impayés Factures / BL, voulez vous continuer? ",
        solder:"Solder les impayés",
        "reminderLine": "Merci pour votre règlement. En cas de solde restant, veuillez régulariser dans les meilleurs délais.",
        annuler:"Annuler",
        noLinesYet:"Aucun lignes",
        addFirstLine:"Ajouter une ligne",
        estFacture:"Facturé",
        chantier: "Chantier",
        totalsMustMatch: "Le montant total doit correspondre au montant des paiements sélectionnés",
        articleName: "Nom de l'article",
        addLine: "Ajouter une ligne",
        prixUnitaireHT: "P.U HT",
        prixUnitaireTTC: "P.U TTC",
        unite: "Unité",
        tauxTVA: "Taux TVA",
        targetTotal: "Total Paiements",
        difference: "Différence",
        currentTotal: "Total Actuel",
        dateEcheance: "Date d'échéance",
        selectedReglements: "Paiements sélectionnés",
        dateFacture: "Date facture",
        createInvoiceTitle: "Créer une facture à partir des paiements",
        createInvoice: "Créer une facture",
        noReglementsSelected: "Aucun règlement sélectionné",
        notesFromDifferentClients: "Les règlements sélectionnés appartiennent à des clients différents",
        invalidReglementTypes: "Certains règlements sélectionnés ne sont pas de type facture ou bon de livraison",
        fetchingBonLivraisons: "Récupération des bons de livraison...",
        errorFetchingBonLivraisons: "Erreur lors de la récupération des bons de livraison",
        invoicePreview: "Aperçu de la facture",
        bonLivraisonRefs: "Réfs. BLs",
        invoiceLines: "Lignes de la facture",
        article: "Article",
        quantite: "Quantité",
        prixUnitaire: "Prix Unitaire",
        montantHT: "Montant HT",
        montantTTC: "Montant TTC",
        montantTotalHT: "Montant Total HT",
        montantTotalTTC: "Montant Total TTC",
        confirmCreateInvoice: "Confirmer",
        confirmCreateInvoiceText: "Voulez-vous créer une facture pour les règlements sélectionnés ?",
        invoiceCreatedSuccess: "Facture créée avec succès",
        invoiceCreationError: "Erreur lors de la création de la facture",
        selectFournisseur: "Sélectionnez...",
        echeancesFournisseur: "Échéances Fournisseurs",
        bonReceptions: "Bons de Réception",
        totalDecaisse: "Total Décaisse",
        decaisse: "Décaisser",
        decaisser: "Décaisser",
        confirmDecaissement: "Confirmer le décaissement",
        decaissementSuccess: "Décaissement effectué avec succès",
        fournisseur: "Fournisseur",
        boReceptions: "Bons Réception",
        fournisseur: "Fournisseur",
        selectFournisseur: "Sélectionner ...",
        listFournisseur: "Paiements Fournisseur",
        nomBonReceptions: "N° Bons de Réception",
        noBRReference: "Aucune référence",
        fournisseurRequired: "Fournisseur requis",
        montantAvances: "Montant des avances",
        avancesDisponibles: "Avances Disponibles",
        motif: "Motif de l'avance",
        dateCreation: "Date de création",
        repartirAutomatiquement: "Répartir automatiquement",
        montantDisponible: "Montant disponible",
        montantAUtiliser: "Montant à utiliser",
        montantTotalUtilise: "Montant total utilisé",
        utilisationPrevue: "Utilisation prévue",
        avancesUtilisees: "Avances utilisées",
        restantARegler: "Restant à régler",
        totalUtilisation: "Total d'utilisation",
        caution: "Caution",
        search: "Recherche",
        noData: "Aucune échéance trouvée.",
        echeancesClients: "Échéances Clients",
        echeancesFournisseurs: "Échéances Fournisseurs",
        montantApresSolde: "Montant après solde",
        createInvoiceInfo: "Créer une facture à partir des paiements",
        createInvoiceDescription: "Créer une facture à partir des paiements",
        summary: "Résumé",
        selectedPayments: "Paiements sélectionnés",
        totalAmount: "Total",
        montant: "Montant",
        selectedPaymentsList: "Liste des paiements sélectionnés",
        proceedToCreateInvoice: "Procéder à la création de la facture",
        createInvoiceFromPayments: "Créer une facture à partir des paiements",
        createInvoice: "Créer une facture",
        acompte_projet: "Acompte Projet",
        commande_future: "Commande future",
        montantTotalARegler: "Montant total à régler",
        nombreDocuments: "Nombre de documents",
        aucuneAvanceDisponible: "Aucune avance disponible pour ce client",
        utiliserAvances: "Utiliser les avances disponibles",
        confirmerUtilisation: "Confirmer l'utilisation des avances",
        documentsARegler: "Documents à régler",
        "type": "Type",
        "validiteJusquau": "Validité jusqu'au",
        "informationsAvance": "Informations sur l'Avance",
        "expire": "Expiré",
        "utilisationAvance": "Utilisation de l'Avance",
        "avancePartiellementUtilisee": "Cette avance a été partiellement utilisée",
        "avance": "Avance",
        "paiementAvance": "Paiement d'Avance",
        "avanceDescription": "Un paiement d'avance permet au client de créditer son compte avant d'avoir des factures ou bons de livraison à régler.",
        "avanceInfo": "Paiement d'avance client",
        "avanceInfoDetail": "Ce montant sera crédité au compte du client et pourra être utilisé pour régler de futures factures ou bons de livraison.",
        "motifAvance": "Motif de l'avance",
        "selectMotifAvance": "Sélectionnez...",
        "commandeFuture": "Commande future",
        "acompteProjet": "Acompte sur projet",
        "creditClient": "Crédit client",
        "dateValiditeAvance": "Date de validité",
        "dateValiditeAvanceHelp": "Date limite d'utilisation de cette avance",
        "commentaireAvance": "Commentaire sur l'avance",
        "commentaireAvancePlaceholder": "Détails sur l'utilisation prévue de cette avance...",
        "resumeAvance": "Résumé de l'Avance",
        "montantAvance": "Montant de l'avance",
        "typeAvance": "Type",
        "avanceCreateSuccess": "Avance créée avec succès",
        "motifAvanceRequired": "Le motif de l'avance est requis",
        "dateValiditeAvanceRequired": "La date de validité est requise",
        "dateValiditeAvanceFuture": "La date de validité doit être dans le futur",
        "informationsComplementaires": "Informations complémentaires",
        "resumeReglement": "Résumé du règlement",
        "referencePlaceholder": "Référence automatique si vide",
        "commentairePlaceholder": "Commentaires ou notes sur ce règlement...",
        "numeroCheque": "Numéro du chèque",
        "referenceVirement": "Référence du virement",
        "numeroTraite": "Numéro de la traite",
        "nomBanque": "Nom de la banque",
        "selectClient": "Sélectionner ...",
        "selectModeReglement": "Choisir le mode de règlement",
        "clientRequired": "Le client est obligatoire",
        "montantPositive": "Le montant doit être positif",
        "montantRequired": "Le montant est obligatoire",
        "dateReglementRequired": "La date de règlement est obligatoire",
        "modeReglementRequired": "Le mode de règlement est obligatoire",
        "statutRequired": "Le statut est obligatoire",
        "createSuccess": "Règlement créé avec succès",
        "updateSuccess": "Règlement modifié avec succès",
        "enAttente": "En attente",
        "valide": "Validé",
        "encaisse": "Encaissé",
        "rejete": "Rejeté",
        "annule": "Annulé",
        "especes": "Espèces",
        "cheque": "Chèque",
        "virement": "Virement",
        "carteBancaire": "Carte bancaire",
        "traite": "Traite",
        "autre": "Autre",
        "factures": "Factures",
        "bonLivraisons": "Bons de livraison",
        "facturesImpayees": "Factures impayées",
        "bonLivraisonsNonRegles": "BL impayés",
        "informationsGenerales": "Informations générales",
        "detailsReglement": "Détails du règlement",
        "client": "Client",
        "typeReglement": "Type de règlement",
        "reference": "Référence",
        "dateReglement": "Date de règlement",
        "dateEncaissement": "Date d'encaissement",
        "montantRegle": "Montant réglé",
        "modeReglement": "Mode règlement",
        "statut": "Statut",
        "referencePaiement": "Référence de paiement",
        "banque": "Banque",
        "dateEcheance": "Date d'échéance",
        "commentaire": "Commentaire",
        "selectDocuments": "Sélectionner les documents",
        "noDocumentsSelected": "Aucun document sélectionné",
        "clickSelectDocuments": "Cliquez sur 'Sélectionner les documents' pour choisir les factures/bons de livraison à régler",
        "documentsSelectionnes": "Documents sélectionnés",
        "montantTotal": "Montant total",
        "totalSelectionne": "Total sélectionné",
        "montantCalculeAutomatiquement": "Montant calculé automatiquement selon les documents sélectionnés",
        "numero": "Numéro",
        "date": "Date",
        "montantPaye": "Montant payé",
        "montantRestant": "Montant restant",
        "partiel": "Partiel",
        "impaye": "Impayé",
        "caution": "Caution",
        "total": "Total",
        "selectFactures": "Sélectionner les factures",
        "selectBonLivraisons": "Sélectionner les bons de livraison",
        "searchDocuments": "Rechercher par numéro, référence ou client...",
        "documentsFound": "document(s) trouvé(s)",
        "documentsSelected": "document(s) sélectionné(s)",
        "documentsSelectionnes": "Documents sélectionnés",
        "noDocumentsFound": "Aucun document trouvé",
        "totalDocuments": "Total documents",
        "selected": "Sélectionnés",
        "montantSelectionne": "Montant sélectionné",
        "selectAllUnpaid": "Sélectionner tous les impayés",
        "selectAllPartial": "Sélectionner tous les partiels",
        "clearSelection": "Vider la sélection",
        "averageAmount": "Montant moyen",
        "client": "Client",
        "montantTTC": "Montant TTC",
        "paiement": "Paiement",
        "impaye": "Impayé",
        "partiel": "Partiel",
        "paye": "Payé",
        "list": "Paiements Clients",
        "new": "Nouveau",
        "edit": "Modifier le Règlement",
        "create": "Créer un Règlement",
        "update": "Mettre à jour",
        "delete": "Supprimer",
        "validate": "Valider",
        "encaisser": "Encaisser",

        "reference": "Référence",
        "client": "Client",
        "clientRequired": "Le client est requis",
        "selectClient": "Sélectionner ...",

        "typeReglement": "Type de Règlement",
        "factures": "Factures",
        "bonLivraisons": "Bons Livraison",

        "montantRegle": "Montant Réglé",
        "montantRequired": "Le montant est requis",
        "montantPositive": "Le montant doit être positif",
        "montantAffecte": "Montant Affecté",
        "montantTotal": "Montant Total",
        "montantPaye": "Montant Payé",
        "montantRestant": "Montant Restant",
        "affecte": "Affecté",

        "dateReglement": "Date Règlement",
        "dateReglementRequired": "La date de règlement est requise",
        "dateEncaissement": "Date d'Encaissement",
        "dateEcheance": "Date d'Échéance",

        "modeReglement": "Mode de Règlement",
        "modeReglementRequired": "Le mode de règlement est requis",
        "selectModeReglement": "Sélectionnez...",
        "especes": "Espèces",
        "cheque": "Chèque",
        "virement": "Virement",
        "carteBancaire": "Carte Bancaire",
        "traite": "Traite",
        "autre": "Autre",

        "statut": "Statut",
        "statutRequired": "Le statut est requis",
        "en_attente": "En Attente",
        "valide": "Validé",
        "encaisse": "Encaissé",
        "rejete": "Rejeté",
        "annule": "Annulé",

        "referencePaiement": "Référence de Paiement",
        "numeroCheque": "Numéro de Chèque",
        "referenceVirement": "Référence de Virement",
        "numeroTraite": "Numéro de Traite",
        "banque": "Banque",
        "nomBanque": "Nom de la Banque",

        "commentaire": "Commentaire",
        "commentairePlaceholder": "Commentaire ou notes sur le règlement...",

        "informationsGenerales": "Informations Générales",
        "detailsReglement": "Détails du Règlement",
        "facturesImpayees": "Factures Impayées",
        "bonLivraisonsNonRegles": "BL impayés",
        "documentsSelectionnes": "Documents sélectionnés",

        "numero": "Numéro",
        "date": "Date",
        "documents": "Documents",
        "partiel": "Partiel",
        "impaye": "Impayé",

        "noFacturesImpayees": "Aucune facture impayée pour ce client",
        "noBonLivraisonsNonRegles": "Aucun bon de livraison non réglé pour ce client",
        "noReglements": "Aucun règlement trouvé",

        "searchPlaceholder": "N° paiement",
        "referencePlaceholder": "Référence du règlement",
        "filterByDate": "Filtrer par date",
        "allStatuts": "Tous les statuts",
        "allModes": "Tous les modes",
        "allClients": "Tous les clients",

        "totalReglements": "Total Règlements",
        "enAttente": "En Attente",
        "encaisses": "Encaissés",
        "montantMoyen": "Montant Moyen",

        "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce règlement ?",
        "confirmValidate": "Êtes-vous sûr de vouloir valider ce règlement ?",
        "confirmEncaissement": "Êtes-vous sûr de vouloir encaisser ce règlement ?",

        "createSuccess": "Règlement créé avec succès",
        "updateSuccess": "Règlement mis à jour avec succès",
        "deleteSuccess": "Règlement supprimé avec succès",
        "validateSuccess": "Règlement validé avec succès",
        "encaissementSuccess": "Règlement encaissé avec succès",
        "rapport": "Rapport des Règlements",
        "filtres": "Filtres",
        "dateDebut": "Date de début",
        "dateFin": "Date de fin",
        "repartitionModes": "Répartition par Mode de Règlement",
        "repartitionStatuts": "Répartition par Statut",
        "listeDetaillee": "Liste Détaillée",
        "totalEncaisse": "Total Encaissé",
        "totalEnAttente": "Total En Attente",
        "montantTotal": "Montant Total",
        "informationsFinancieres": "Informations Financières",
        "detailsPaiement": "Détails du Paiement",
        "documentsAssocies": "Documents Associés",
        "aucunDocumentAssocie": "Aucun document associé",
        "detail": "Détail du Règlement",
        "noData": "Aucune donnée pour la période sélectionnée",
        "notifications": "Notifications Règlements",
        "reglementsEnRetard": "Règlements en Retard",
        "echeanceProche": "Échéances Proches",
        "joursRetard": "jours de retard",
        "joursRestants": "jours restants",
        "gestionReglements": "Gestion des Règlements",
        "statistiques": "Statistiques",
        "totalMoisCourant": "Total mois courant",
        "recents": "Récents",
        "voirTous": "Voir tous",
        "aucunEnAttente": "Aucun règlement en attente",
        "aucunRecent": "Aucun règlement récent"
      },
      "subInvoice": {
        "title": "Sous-Factures",
        "parentInvoice": "Facture Parent",
        "allocated": "Alloué",
        "remaining": "Restant",
        "totalParent": "Total Parent",
        "totalAllocated": "Total Alloué",
        "newSubInvoicesCount": "Nouvelles sous-factures",
        "number": "Numéro",
        "amount": "Montant",
        "description": "Description",
        "status": "Statut",
        "existing": "Existante",
        "created": "Créée",
        "draft": "Brouillon",
        "delete": "Supprimer",
        "addSubInvoice": "Ajouter Sous-Facture",
        "distributeEvenly": "Répartir Équitablement",
        "balanced": "Équilibré",
        "unbalanced": "Déséquilibré",
        "createSubInvoices": "Créer les Sous-Factures",
        "descriptionPlaceholder": "Description de la sous-facture...",
        "noSubInvoices": "Aucune sous-facture",
        "instructions": "Instructions",
        "instruction1": "Le montant total des sous-factures doit être égal au montant de la facture parent",
        "instruction2": "Utilisez 'Répartir Équitablement' pour diviser le montant restant",
        "instruction3": "Les sous-factures existantes ne peuvent pas être modifiées",
        "instruction4": "Ajoutez une description pour identifier chaque sous-facture",
        "noRemainingAmount": "Aucun Montant Restant",
        "noRemainingAmountMessage": "Il n'y a plus de montant à allouer pour créer une nouvelle sous-facture.",
        "cannotDeleteExisting": "Suppression Impossible",
        "cannotDeleteExistingMessage": "Les sous-factures déjà créées ne peuvent pas être supprimées.",
        "invalidTotal": "Total Invalide",
        "invalidTotalMessage": "Le total des sous-factures doit être égal au montant de la facture parent.",
        "noNewSubInvoices": "Aucune Nouvelle Sous-Facture",
        "noNewSubInvoicesMessage": "Il n'y a aucune nouvelle sous-facture à créer.",
        "invalidAmounts": "Montants Invalides",
        "invalidAmountsMessage": "Tous les montants des sous-factures doivent être supérieurs à zéro.",
        "confirmCreation": "Confirmer la Création",
        "confirmCreationMessage": "Voulez-vous créer {{count}} sous-facture(s) ?",
        "remainingAmountWarning": "Il reste {{amount}} à allouer.",
        "excessAmountWarning": "Le total dépasse de {{amount}} le montant de la facture parent.",
        "cannotCreateForCancelled": "Création Impossible",
        "cannotCreateForCancelledMessage": "Impossible de créer des sous-factures pour une facture annulée.",
        "invalidAmount": "Montant Invalide",
        "invalidAmountMessage": "Le montant de la facture doit être supérieur à zéro.",
        "created": "Sous-Factures Créées",
        "createdMessage": "{{count}} sous-facture(s) créée(s) avec succès.",
        "creationError": "Erreur de Création",
        "creationErrorMessage": "Une erreur est survenue lors de la création des sous-factures.",
        "noSelection": "Aucune Sélection",
        "noSelectionMessage": "Veuillez sélectionner au moins une facture.",
        "bulkCreation": "Création en Lot",
        "bulkCreationMessage": "Créer des sous-factures pour {{count}} facture(s) sélectionnée(s) ?",
        "createForSelected": "Créer pour Sélectionnées",
        "hasSubInvoices": "A des sous-factures",
        "viewSubInvoices": "Voir les sous-factures"
      },
      sale: {
        error: " Une erreur est survenue",
        orderDetails: "Détails de la commande",
        confirmSale: "Confirmer la vente",
        clientPassager: "Client Passager",
        newSale: "Nouvelle vente",
        successTitle: "Vente Réussie",
        successMessage: "La vente a été enregistrée avec succès",
        errorTitle: "Erreur",
        errorMessage: "Une erreur est survenue lors de la vente",
        viewHistory: "Historique des ventes",
        pageTitle: "Point de Vente",
        receipt: {
          totalQuantity: "Quantité Totale",
          seller: "Vendeur",
          unite: "Unité",
          discount: "Remise",
          title: "Ticket de Caisse",
          date: "Date",
          items: "Articles",
          total: "Total",
          quantity: "Qté",
          price: "Prix",
          subtotal: "Total",
          thank: "Merci de votre visite",
          title: "Ticket de caisse",
          store: "Nom du magasin",
          date: "Date",
          tel: "Tél: +212 123456789",
          receiptNo: "Ticket N°",
          cashier: "Caissier",
          paid: "Montant payé",
          change: "Monnaie à rendre",
          tax: "TVA",
          thankYou: "Merci de votre visite",
          footer: "À bientôt !",

        },
        confirmTitle: "Confirmer la vente",
        amountDue: "Montant à payer",
        paymentAmount: "Montant payé",
        changeAmount: "Monnaie à rendre",
        insufficientAmount: "Montant insuffisant",
        checkPamountDue: "Montant dû",
        amountPaid: "Montant payé",
        changeAmount: "Monnaie à rendre",
        confirmDelete: "Êtes-vous sûr de vouloir supprimer cette vente ?",
        confirmDeleteItem: "Êtes-vous sûr de vouloir supprimer cet article ?",
        deleteSuccess: "Vente supprimée avec succès",
        deleteError: "Erreur lors de la suppression de la vente",
        deleteItemSuccess: "Article supprimé avec succès",
        deleteItemError: "Erreur lors de la suppression de l'article",
        items: "Articles de la vente",
        deleteItemConfirmTitle: "Supprimer l'article",
        deleteItemConfirmText: "Voulez-vous vraiment supprimer cet article de la vente ?",
        item: {
          product: "Produit",
          quantity: "Quantité",
          price: "Prix",
          total: "Total"
        },
      },
      cart: {
        totalHT: "Total HT",
        totalTVA: "Total TVA",
        totalTTC: "Total TTC",
        tva: "TVA (20%)",
        title: "Panier",
        save: "Sauvegarder",
        clear: "Vider",
        empty: "Votre panier est vide",
        clearConfirmTitle: "Vider le panier",
        clearConfirmMessage: "Êtes-vous sûr de vouloir vider le panier ?",
        confirm: "Confirmer",
        cancel: "Annuler",
        unitPrice: "Prix U.T.",
        quantity: "Qté",
        title: "Panier",
        items: "articles",
        total: "Total à payer",
        totalItems: "Total articles: {{count}}",
        subtotal: "Total",
        discount: "Remise",
        tax: "TVA ({{rate}}%)",
        checkout: "Valider la commande",
        checkoutProcessing: "Traitement en cours...",
        checkoutSuccess: "Commande validée",
        checkoutError: "Erreur lors de la validation"
      },
      avoir: {
        title: "Avoir",
        pageTitle: "Avoir",
        invoiceNumber: "N° Facture",
        invoiceDate: "Date de Facture",
        invoiceLieu: "Lieu de Facture",
        modeReglement: "Mode de règlement",
        numeroCheque: "N° chèque",
        save: "Enregistrer",
        cancel: "Annuler",
        isRequired: "Obligatoire",
        newInvoice: "Nouvelle Avoir",
        totalHt: "Total HT",
        tva: "TVA",
        totalTtc: "Total TTC",
        savedSuccess: "Avoir enregistrée avec succès",
        updatedSuccess: "Avoir modifiée avec succès",
        saveOrConfirmText: "Voulez-vous enregistrer et confirmer cet avoir ? Une fois confirmée, l'avoir ne pourra plus être modifiée.",
        confirmation: "Confirmation",
        product: "Produit",
        quantityToReturn: "Quantité à retourner",
        unitPrice: "Prix UT",
      },
      summary: {
        exportBtn: "Exporter",
        totalFactureAmount: "Total des factures",
        totalAvoirAmount: "Total des avoirs",
        soldeDu: "Solde dû",
        suppliersInvoicesState: "État des factures fournisseurs",
        totalAmountPaid: "Total des paiements",
        generateReleve: "Générer un relevé",
      },
      facture: {
        numeroFactfournisseur: "N° Facture Fournisseur",
        impaye: "Impayé",
        prixUnitaireTTC: "P.U. TTC",
        dateOperation: "Date d'opération",
        filterPlaceholder: "Rechercher par numéro, référence ou client...",
        partiellement_payee: "Partiellement payée",
        encours: "En cours paiement",
        createInvoiceFromPayments: "Créer une facture à partir des paiements",
        selectPaymentsForInvoice: "Sélectionnez les paiements pour la facture",
        selectedPayments: "Paiements sélectionnés",
        createdFromPayments: "Créé à partir des paiements",
        noArticles: "Aucun article",
        fromPayments: "Créer une facture à partir des paiements",
        createFromPayments: "Créer une facture à partir des paiements",
        dueDate: "Date d'échéance",
        dateFacture: "Date facture",
        preview: "Prévisualiser",
        statistics: "Statistiques",
        totalLines: "Total lignes",
        totalQuantity: "Total quantité",
        "commentaire": "Commentaire",
        "commentairePlaceholder": "Commentaire ou notes sur la facture...",
        articles: "Articles",
        code: "Code",
        designation: "Désignation",
        quantite: "Qté",
        unite: "Unité",
        prixUnitaireHT: "PH UT",
        tauxTVA: "TVA (%)",
        montantHT: "Total HT",
        montantTTC: "Total TTC",
        totalHT: "Total HT",
        totalTTC: "Total TTC",
        montantRegle: "Montant réglé",
        montantRestant: "Montant restant",
        banque: "Banque",
        summary: "Résumé",
        editInvoice: "Modifier la facture",
        enterBanque: "Entrez le nom de la banque",
        enterNumeroCheque: "Entrez le numéro de chèque",
        totalInvoices: "Total des factures",
        list: "Factures",
        paidAmount: "Montant payé",
        pendingAmount: "Montant impayé",
        "brouillon": "Brouillon",
        "validee": "Validée",
        "partiellementPayee": "Partiellement payée",
        "payee": "Payée",
        "enRetard": "En retard",
        clientRequired: "Sélectionnez un client",
        clientRequiredMessage: "Le client est obligatoire",
        totalUnpaid: "Total impayé",
        totalPaid: "Total payé",
        unpaid: "Impayé",
        fullyPaid: "Entièrement payé",
        factures: "Factures",
        totalAmount: "Montant total",
        confirmSubmit: "Confirmer la soumission",
        confirmSubmitMessage: "Voulez-vous vraiment soumettre cette facture ?",
        validation: {
          paymentMethodRequired: "Sélectionnez un mode de règlement",
          paymentMethodRequiredMessage: "Le mode de règlement est obligatoire",
          dueDateRequired: "Sélectionnez une date d'échéance",
          dueDateRequiredMessage: "La date d'échéance est obligatoire",
        },
        dateEcheance: "Date d'échéance",
        observations: "Observations",
        comptant: "Comptant",
        days: "Jours",
        paymentTerms: "Conditions de paiement",
        productCode: "Code Produit",
        unit: "Unité",
        unitPriceHT: "P.U. HT",
        title: "Facture",
        numero: "N° Facture",
        date: "Date création",
        montant: "Montant",
        client: "Client",
        annulee: "Annulée",
        bl: "N° BL",
        status: "Statut",
        validated: "Validée",
        cancelled: "Annulée",
        partiallyPaid: "Partiellement payé",
        IMPAYE: "En cours paiement",
        "cannotEditCancelled": "Modification impossible",
        "cannotEditCancelledMessage": "Cette facture ne peut pas être modifiée car elle a été annulée.",
        "cannotEditPaid": "Modification impossible",
        "cannotEditPaidMessage": "Cette facture ne peut pas être modifiée car elle est entièrement payée.",
        "cannotEditPartiallyPaid": "Modification impossible",
        "cannotEditPartiallyPaidMessage": "Cette facture ne peut pas être modifiée car elle contient des paiements partiels.",
        "deliveryReferences": "Réfs. BL",
        "deliveryReferencesNote": "Cette facture est liée aux bons de livraison ci-dessus",
        "checkDetails": "Détails du chèque",
        "numeroCheque": "Numéro de chèque",
        "enterNumeroCheque": "Saisissez le numéro de chèque",
        "banque": "Banque",
        "enterBanque": "Nom de la banque",
        "dateEcheanceCheque": "Date d'échéance du chèque",
        "selectClient": "Sélectionnez...",
        "noLines": "Aucune ligne",
        "noLinesMessage": "Veuillez ajouter au moins un article à la facture.",
        newInvoice: "Nouvelle Facture",
        factureAvoir: "Facture d'avoir",
        referenceNumber: "Réf. paiement / N° de chèque",
        dateReglement: "Date de paiement",
        invoiceDetails: "Details de la Facture",
        invoiceSavedMessage: "Facture enregistrée avec succès",
        invoiceSaved: "Facture enregistrée",
        invoiceLines: "Lignes de Facture",
        newInvoice: "Nouvelle Facture",
        noInvoices: "Aucune facture trouvée",
        paid: "Payée",
        cash: "Espèces",
        creditCard: "Carte bancaire",
        check: "Chèque",
        transfer: "Virement",
        paymentStatus: "Statut de paiement",
        paymentDate: "Date de paiement",
        paymentMethod: "Mode de paiement",
        comment: "Commentaire",
        receiptNote: "Bon de réception",
        supplier: "Fournisseur",
        productDescription: "Produit",
        quantity: "Quantité",
        unitPrice: "Prix UT",
        period: "Période",
        filter: "Filtrer",
        dateTo: "Date de fin",
        dateFrom: "Date de début",
        totalAmountHT: "Total HT",
        totalAmountTTC: "Total TTC",
        addLine: "Ajouter une ligne",
        "invoiceType": "Type",
        "invoiceType.facture": "Facture",
        "invoiceType.devis": "Devis",
        "invoiceNumber": "N° Facture",
        "buyingInvoiceNumber": "N° Facture d'Achat",
        "invoiceDate": "Date de Facture",
        "invoiceLieu": "Lieu de Facture",
        "modeReglement": "Mode de règlement",
        "etat": "Type de règlement",
        "modeReglement.espece": "Espèce",
        "modeReglement.cheque": "Chèque",
        "modeReglement.virement": "Virement",
        "modeReglement.card": "Carte bancaire",
        "numeroCheque": "N° chèque",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "isRequired": "Obligatoire",
        "newInvoice": "Nouvelle Facture",
        "totalHt": "Total HT",
        "tva": "TVA",
        totalTVA: "Total TVA (20%)",
        "totalTtc": "Total TTC",
        "savedSuccess": "Facture enregistrée avec succès",
        "updatedSuccess": "Facture modifiée avec succès",
        table: {
          blNumbers: "N° BL",
          receiptNumbers: "Bon de réception",
          isFromCaisse: "Caisse",
          "invoiceNb": "N° Facture",
          "clientName": "Nom Client",
          "Date": "Date Facture",
          "totalHt": "Total HT",
          "totalTtc": "Total TTC",
          paidAmount: "Montant payé",
          "actions": "Actions",
          status: "Statut",
        },
        actions: "Actions",
        noInvoices: "Aucune facture trouvée",
        "factures": "Factures",
        "newFacture": "Nouvelle Facture",

        fournisseur: {
          "title": "Fournisseur",
          "code": "Code Fournisseur",
          "businessName": "Nom de l'entreprise",
          "nameSupplier": "Nom du fournisseur",
          "adresse": "Adresse",
          "city": "Ville",
          "phoneNbr": "Numéro de téléphone",
          "email": "Email",
          "selected": "Fournisseur choisi",
          "ice": "ICE",
          "newSupplier": "Nouveau Fournisseur",
          "savedSuccess": "Fournisseur enregistré avec succès",
          "choseSupplier": "Choisir un fournisseur",
          "selectSupplier": "Sélectionnez votre fournisseur",
          "create": "Créer un fournisseur",
          "suppliers": "Gestion de Fournisseurs",
          "relevee": "Relevée",
          "edit": "Modifier",
          "actions": "Actions",
        },

        "cannotUpdate": "Modification impossible",
        "cannotUpdateMessage": "Cette facture ne peut pas être modifiée car elle est payée ou annulée.",
        "readOnly": "Lecture seule",
        "readOnlyWarning": "Attention !",
        "readOnlyWarningMessage": "Cette facture ne peut pas être modifiée.",
        "updateSuccess": "Facture mise à jour",
        "updateSuccessMessage": "La facture a été mise à jour avec succès.",
        "updateError": "Erreur de mise à jour",
        "updateErrorMessage": "Une erreur est survenue lors de la mise à jour de la facture.",
        "createSuccess": "Facture créée",
        "createSuccessMessage": "La facture a été créée avec succès.",
        "createError": "Erreur de création",
        "createErrorMessage": "Une erreur est survenue lors de la création de la facture.",
        "confirmCancel": "Annuler la facture",
        "confirmCancelMessage": "Êtes-vous sûr de vouloir annuler cette facture ? Cette action est irréversible.",
        "cancelReason": "Motif d'annulation",
        "enterCancelReason": "Saisissez le motif d'annulation...",
        "cancelReasonRequired": "Le motif d'annulation est obligatoire",
        "confirmCancelButton": "Oui, annuler",
        "cancelInvoice": "Annuler la facture",
        "cancelSuccess": "Facture annulée",
        "cancelSuccessMessage": "La facture a été annulée avec succès.",
        "cancelError": "Erreur d'annulation",
        "cancelErrorMessage": "Une erreur est survenue lors de l'annulation de la facture.",
        deliveryReferencesNote: "Note de référence de livraison",
        deliveryReferences: "Références de livraison",
      },
      devis: {
        prixStandard:"P.U Stan.",
        chantier: "Chantier",
        dateCreation: "Date de création",
        dateOperation: "Date d'opération",
        montantPaye: "Montant payé",
        dateModification: "Date modification",
        montantTVA: "Total TVA",
        noClientFound: "Aucun client trouvé",
        noClientTitle: "Aucun client trouvé",
        noClientMessage: "Veuillez ajouter un client avant de créer un devis",
        validite: "Validité",
        jours: "Jours",
        unite: "Unité",
        cancel: "Annuler",
        edit: "Modifier",
        devisValide: "Bon de commande",
        downloadPdf: "Télécharger",
        updatedSuccess: "Devis modifié avec succès",
        savedSuccess: "Devis enregistré avec succès",
        validation: {
          clientRequired: "Sélectionnez un client",
          atLeastOneItem: "Ajoutez au moins un article",
        },
        editDevis: "Devis",
        newDevis: "Nouveau Devis",
        statusDraft: "En attente",
        statusValidated: "Validé",
        statusCancelled: "Annulé",
        accepted: "Accepté",
        items: "Articles",
        noLines: "Aucune ligne ajoutée",
        addLine: "Ajouter une ligne",
        "totalTaxe": "Total TVA",
        "totalTTC": "Total TTC",
        "prixUnitaireTTC": "P.U. (TTC)",
        "montantTTC": "Montant Total (TTC)",
        "prixVente": "P.V. (HT)",
        "prixVenteHT1": "Prix Vente HT 1",
        "prixVenteHT2": "Prix Vente HT 2",
        "prixVenteHT3": "Prix Vente HT 3",
        "selectPrice": "Sélectionnez un prix",
        "selectArticle": "Sélectionnez un article",
        "selectClient": "Sélectionnez...",
        noDevis: "Aucun devis trouvé",
        filterPlaceholder: "Rechercher un devis...",
        dateCreation: "Date de création",
        montant: "Montant",
        status: "Statut",
        list: "Liste des devis",
        "article": "Article",
        "quantite": "Qté",
        "prixUnitaireHT": "PU HT",
        "tauxTVA": "Taux TVA",
        "remise": "Remise",
        "montantHT": "Total (HT)",
        "montantTaxe": "Montant Taxe",
        "montantTTC": "Total (TTC)",
        "totalHT": "Total HT",
        "actions": "Actions",
        "delete": "Supprimer",
        "addLine": "Ajouter une ligne",
        "noItems": "Aucun article disponible",
        dateExpiration: "Date d'expiration",
        client: "Client",
        remarques: "Remarques",
        "newDevis": "Nouveau Devis",
        numero: "N° Devis",
      },
      delivery: {
        annulee:"Annulée",
        confirmCancel:"Annuler bon de livraion ?",
        confirmCancelMessage:"Êtes-vous sûr de vouloir annuler cette facture ? Cette action est irréversible.",
        cancelReasonRequired: "Le motif d'annulation est obligatoire",
        enterCancelReason: "Saisissez le motif d'annulation...",
        cancelReason: "Motif d'annulation",
        confirmCancelButton:"Oui, annuler",
        "cancelSuccess": "BL annulée",
        "cancelSuccessMessage": "BL facture a été annulée avec succès.",
        "cancelError": "Erreur d'annulation",
        "cancelErrorMessage": "Une erreur est survenue lors de l'annulation du BL.",
        chantier: "Chantier",
        vendeur: "Vendeur",
        selectCommercial: "Sélectionnez...",
        commercial: "Commercial",
        importer: "Importer",
        uploadSuccess: "Téléchargement réussi",
        dateOperation: "Date d'opération",
        regle: "Paiement",
        "enpreparation": "En préparation",
        "encours": "En cours",
        "livre": "Livré",
        "retourne": "Retourné",
        invoiced: "Facturé",
        paid: "Payé",
        delivered: "Livré",
        total: "Total (BL / Point de vente)",
        numeroFacture: "N° Facture",
        deliveryNotes: "Bons de livraison",
        createInvoice: "Créer une facture",
        facture: "Facturé",
        notesFromDifferentClients: "Bons de livraison de différents clients",
        accuse: "Accusé",
        enpreparation: "En préparation",
        pdfWithPrices: "BL avec prix",
        pdfWithoutPrices: "BL sans prix",
        noBL: "Aucun bon de livraison trouvé",
        new: "Nouveau",
        encours: "En cours",
        livre: "Livré",
        retourne: "Retourné",
        commande: "N° BC",
        status: "Statut",
        numero: "N° BL",
        dateCreation: "Date de création",
        blDirect: "BL Comptoir",
        list: "Bons de livraison",
        "deliveryType": "Type",
        "deliveryType.delivery": "Bon de livraison",
        "deliveryNumber": "N° BL",
        "deliveryDate": "Date livraison",
        "deliveryLieu": "Lieu de Bon de livraison",
        "modeReglement": "Mode de règlement",
        "modeReglement.espece": "Espèce",
        "modeReglement.cheque": "Chèque",
        "numeroCheque": "N° chèque",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "isRequired": "Obligatoire",
        "newInvoice": "Nouvelle Bon de livraison",
        "invoiceNb": "N° Facture",
        "commandNb": "N° Commande",
        "totalHt": "Total HT",
        "tva": "TVA",
        "totalTtc": "Total TTC",
        "savedSuccess": "Bon de livraison enregistrée avec succès",
        table: {
          "deliveryNb": "N° Bon de livraison",
          "clientName": "Nom Client",
          "Date": "Date",
          "totalHt": "Total HT",
          "totalTtc": "Total TTC",
          "actions": "Actions",
        },
        "delivery": "Bon de livraison",
        "newDelivery": "Nouvelle Bon de livraison",
        client: {
          etatClient:"Etat client",
          echeances: "Échéances",
          cautions: "Cautions",
          code: "Code",
          nom: "Nom",
          "title": "Client",
          "create": "Créer un client",
          "type": "Type",
          "particulier": "Particulier",
          "entreprise": "Entreprise",
          "selectClient": "Sélectionnez...",
          "businessName": "Nom de l'entreprise",
          "adresse": "Adresse",
          "ice": "ICE",
          "email": "Email",
          "fullName": "Nom complet",
          "phoneNbr": "Numéro de téléphone",
          "newClient": "Nouveau Client",
          "cinNbr": "CIN N°",
          "cinExpirationDate": "Date d'expiration CIN",
          "city": "Ville",
          "firstName": "Prénom",
          "lastName": "Nom",
          "gender": "Genre",
          "savedSuccess": "Client enregistré avec succès",
          "choseClient": "Choisir un client",
          "selected": "Sélectionner",
          "clients": "Clients",
          "clientChosen": "Client choisi",
        },
        fournisseur: {
          "title": "Fournisseur",
          "businessName": "Nom de l'entreprise",
          "adresse": "Adresse",
          "city": "Ville",
          "phoneNbr": "Numéro de téléphone",
          "email": "Email",
          "ice": "ICE",
        },
      },
      commande: {
        commercial: "Commercial:",
        dateOperation: "Date d'opération",
        transporteur: "Transporteur",
        transporteurRequired: "Sélectionnez un transporteur",
        selectTransporteur: "Sélectionnez...",
        selectEntrepot: "Sélectionnez...",
        entrepot: "Entrepôt",
        dateModification: "Date modification",
        comptant: "Comptant",
        editCommande: "Modifier Commande",
        noCommande: "Aucune commande trouvée",
        modeReglement: "Mode de règlement",
        remarques: "Remarques",
        dateLivraisonPrevue: "Date livraison prévue",
        selectClient: "Sélectionner ...",
        downloadPdf: "Télécharger",
        edit: "Modifier",
        cancel: "Annuler",
        newCommande: "Nouvelle Commande",
        dateCreation: "Date création",
        bonLivraison: "Bon de livraison",
        statusDraft: "En attente de validation",
        statusValidated: "Validée",
        statusCancelled: "Annulée",
        statusPartiallyDelivered: "Partiellement livrée",
        statusDelivered: "Livrée",
        devis: "N° Devis",
        list: "Bon de commandes",
        filterPlaceholder: "Rechercher une commande...",
        dateCommande: "Date",
        status: "Statut",
        montant: "Montant",
        numero: "N° Commande",
        client: "Client",
        noCommandes: "Aucune commande trouvée",
        updatedSuccess: "Bon de commande modifiée avec succès",
        savedSuccess: "Bon de commande enregistrée avec succès",
        entrepotRequired: "Sélectionnez un entrepôt",
        clientRequired: "Sélectionnez un client",


      },

      bonLivraison: {
        selectModeReglement: "Sélectionnez...",
        dateOperation: "Date d'opération",
        entrepotRequired: "Sélectionnez un entrepôt",
        confirmAccuser: "Confirmer l'accusé de réception",
        livrer: "Livrer",
        accuser: "Accusé de réception",
        confirmLivrer: "Confirmer la livraison",
        updatedSuccess: "Bon de livraison modifiée avec succès",
        transporteurRequired: "Sélectionnez un transporteur",
        savedSuccess: "Bon de livraison enregistrée avec succès",
        atLeastOneItem: "Ajoutez au moins un article",
        modeReglement: "Mode de paiement",
        modePaiementRequired: "Sélectionnez un mode de paiement",
        new: "Nouveau bon de livraison",
        edit: "Modifier",
        comptant: "Comptant",
        client: "Client",
        entrepot: "Entrepôt",
        dateLivraison: "Date livraison",
        modeReglement: "Mode de règlement",
        transporteur: "Transporteur",
        remarques: "Remarques",
        selectClient: "Sélectionnez...",
        selectEntrepot: "Sélectionnez...",
        selectTransporteur: "Sélectionnez...",
        addresseLivraison: "Adresse de livraison",
      },
      transporteur: {
        title: "Transporteurs",
        new: "Nouveau transporteur",
        code: "Code",
        name: "Nom",
        adresse: "Adresse",
        phoneNbr: "Numéro de téléphone",
        email: "Email",
        newTransporteur: "Nouveau Transporteur",
        savedSuccess: "Transporteur enregistré avec succès",
        editSuccess: "Transporteur modifié avec succès",
        deleteConfirmTitle: "Supprimer le transporteur ?",
        deleteConfirmText: "Cette action ne peut pas être annulée",
        deleted: "Transporteur supprimé",
        updated: "Transporteur mis à jour",
      },
      reception: {
        allReceived: "Tout reçu",
        statuts: "Statuts",
        dateReception: "Date de réception",
        selectOrder: "Sélectionner une commande",
        noOrderFound: "Aucune commande trouvée",
        missingEntrepotTitle: "Entrepôt manquant",
        missingEntrepotMessage: "Veuillez sélectionner un entrepôt avant de soumettre.",
        selectFournisseur: "Sélectionnez...",
        originalCommande: "Commande d'origine",
        entrepot: "Entrepôt",
        dateOperation: "Date d'opération",
        noRC: "Aucun bon de réception trouvé",
        importer: "Importer",
        "pdfWithPrices": "PDF avec prix",
        "pdfWithoutPrices": "PDF sans prix",
        total: "Total",
        invoiced: "Facturé",
        paid: "Payé",
        validated: "Validé",
        facture: "Facturé",
        numeroFacture: "N° Facture",
        notAllConfirmed: "Bon de réception non confirmé",
        entrepotMissing: "Veuillez sélectionner un entrepôt",
        receivedQuantityMinValue: "La quantité reçue doit être supérieure à 0",
        receivedQuantityMissing: "Veuillez saisir la quantité reçue",
        atLeastOneLine: "Veuillez ajouter au moins une ligne",
        supplierMissing: "Veuillez sélectionner un fournisseur",
        deliveryNoteMissing: "Veuillez saisir un bon de livraison",
        dateMissing: "Veuillez sélectionner une date de réception",
        missingDeliveryNoteTitle: "Aucun bon de livraison trouvé",
        missingDeliveryNoteMessage: "Vous devez d'abord saisir un N° BL avant de créer un bon de réception",
        prixUnitaireHT: "P.U. HT",
        receiptNotes: "Bon de réception",
        validateReceiptNote: "Valider la réception",
        confirmValidateMessage: "Voulez-vous vraiment valider ce bon de réception ?",
        confirmValidate: "Valider",
        validatedSuccess: "Bon de réception validé avec succès",
        validateError: "Erreur lors de la validation du bon de réception",
        totalHt: "Total HT",
        totalTtc: "Total TTC",
        totalTva: "Total TVA",
        tva: "TVA",
        noteFromifferentSuppliers: "Bon de réception de différents fournisseurs",
        noteNotAllConfirmed: "Bon de réception non confirmé",
        createInvoice: "Créer Facture",
        supplier: "Fournisseur",
        title: "Bon de Réception",
        status: "Statut",
        unitPrice: "Prix UT",
        newReception: "Nouvelle réception",
        savedSuccess: "Réception enregistrée avec succès",
        new: "Bon de Réception",
        purchaseOrderNumber: "N° Commande",
        receiptNumber: "Réf.",
        deliveryNoteNb: "N° BL Fournisseur",
        receiptDate: "Date Réception",
        productDescription: "Produit",
        orderedQuantity: "Qté Commandée",
        receivedQuantity: "Qté Reçue",
        line: "Ligne",
        confirmSaveMessage: "Voulez-vous enregistrer cette réception ?",
        confirmSave: "Enregistrer",
        confirmCancel: "Annuler",
        saveError: "Erreur lors de l'enregistrement de la réception",
      },
      fournisseur: {
        noData: "Aucune donnée disponible",
        code: "Code",
        nom: "Nom",
        contact: "Contact",
        solde: "Solde",
        new: "Nouveau Fournisseur",
        searchPlaceholder: "Rechercher un fournisseur..."
      },
      purchase: {
        noFournisseurTitle: "Aucun fournisseur trouvé",
        noFournisseurMessage: "Veuillez ajouter un fournisseur avant de créer une commande",
        noOrdersFound: "Aucune commande trouvée",
        unitPriceTTC: "P.U. TTC",
        unitPriceHT: "P.U. HT",
        noSupplierTitle: "Aucun fournisseur trouvé",
        noSupplierMessage: "Veuillez ajouter un fournisseur avant de créer une commande",
        dateCreation: "Date création",
        invoiceNumber: "N° Facture",
        deliveryAddress: "Adresse de livraison",
        product: "Produit",
        quantity: "Quantité Demandée",
        unitPrice: "P.U. HT",
        dateModification: "Date modification",
        montantHT: "Total HT",
        tauxTVA: "TVA",
        montantTTC: "Total TTC",
        receivedQuantity: "Quantité Reçue",
        newReception: "Nouvelle réception",
        savedSuccess: "Commande enregistrée avec succès",
        confirmation: "Confirmation",
        saveOrConfirm: "Enregistrer et confirmer",
        saveOrConfirmText: "Voulez-vous enregistrer et confirmer cette commande ? Une fois confirmée, la commande ne pourra plus être modifiée.",
        selectSupplier: "Sélectionnez...",
        noSupplierFound: "Aucun fournisseur trouvé",
        chooseProduct: "Choisir un produit",
        productExistsMessage: "Ce produit existe déjà dans la commande",
        productExistsTitle: "Produit existant",
        noItems: "Aucun article dans la commande",
        addFirstItem: "Ajouter un article",
        orders: "Commandes",
        newOrder: "Nouvelle Commande",
        orderNumber: "N° Commande",
        supplier: "Fournisseur",
        orderDate: "Date de Commande",
        totalAmount: "Montant Total",
        actions: "Actions",
        orderLieu: "Lieu de Commande",
        filter: "Filtrer",
        period: "Période",
        dateTo: "Date de fin",
        dateFrom: "Date de début",
        totalAmountTtc: "Montant TTC",
        totalAmountHt: "Montant HT",
        dateOperation: "Date d'opération",
        statut: {
          title: "Statut",
          draft: "Brouillon",
          ordered: "Commandée",
          received: "Reçue",
          invoiced: "Facturée",
          paid: "Payée",
          canceled: "Annulée",
        }
      },
      unites: {
        code: "Code",
        label: "Libellé",
        new: "Nouvelle unité",
        list: "Liste des unités",
        noUnites: "Aucune unité trouvée",
        addSuccess: "Unité ajoutée avec succès",
        editSuccess: "Unité modifiée avec succès",
        deleteConfirmTitle: "Supprimer l'unité ?",
        deleteConfirmText: "Cette action ne peut pas être annulée",
        deleted: "Unité supprimée",
        updated: "Unité mise à jour",
      },
      entrepot: {
        libelle: "Entrepôt",
        default: "Principal",
        title: "Entrepôts",
        new: "Nouvel entrepôt",
      },
      statistics: {
        clientCode: "Code",
        phone: "Téléphone",
        blNumber: "N° BL",
        date: "Date",
        designation: "Désignation",
        unit: "Unité",
        unitPrice: "P.U.",
        lineTotal: "Total",
        total: "Total",
        totalConsumed: "Total consommé",
        previousBalance: "Solde précédent",
        advance: "Avance",
        credit: "Crédit",
        netToPay: "Net à payer",
        amountInWords: "Montant en lettres",
        periodNote: "Note de période",
        to: "à",
        client: "Clients",
        selectClient: "Sélectionner ...",
        generateReport: "Générer un rapport",
        clientReport: "Rapport des clients",
        salesOverTime: "Évolution des ventes",
        salesStatistics: "Statistiques des ventes",
        totalSales: "Total des ventes",
        directSales: "Ventes directes",
        posSales: "Ventes Comptoire",
        salesReturns: "Retours",
        invoiceStatus: "État des factures",
        salesBreakdown: "Répartition des ventes",
        invoicesPaid: "Factures payées",
        invoicesUnpaid: "Factures impayées",
        invoicesPartiallyPaid: "Factures partiellement payées",
        period: "Période",
        summary: "Résumé",
        salesReport: "Rapport des ventes",
        salesAmount: "Montant des ventes",
        salesDistribution: "Distribution des ventes",
        invoiceSales: "Ventes par factures",
        paid: "Payé",
        unpaid: "Impayé",
        partiallyPaid: "Partiellement payé",
        sales: "Ventes",
        returns: "Retours",
        amount: "Montant",
        paymentStatus: "Statut de paiement",
        overview: "Aperçu",
        distribution: "Distribution",
        comparison: "Comparaison",
        salesVsReturns: "Ventes vs Retours",
        thisWeek: "Cette semaine",
        thisMonth: "Ce mois",
        thisYear: "Cette année",
        custom: "Personnalisé",
        startDate: "Date de début",
        endDate: "Date de fin",
        topSellingProducts: "Produits les plus vendus",
        product: "Produit",
        quantity: "Quantité",
        revenue: "Revenu",
        noData: "Aucune donnée disponible",
        metric: "Métrique",
        value: "Valeur",
        generatedOn: "Généré le"
      },
      retourFournisseur: {
        list: "Retours fournisseur",
        new: "Nouveau",
        edit: "Modification",
        searchPlaceholder: "Rechercher un retour fournisseur",
        selectBR: "Sélectionnez...",
        invoice: "Facture",
        br: "Bon de réception",
        none: "Aucun",
        originalInvoice: "Facture d'origine",
        originalBR: "Bon de réception d'origine",
        dateOperation: "Date d'opération",
        dateRetour: "Date de retour",
        dateCreation: "Date de création",
        dateModification: "Date de modification",
        refundMode: "Type retour",
        numero: "Numéro",
        fournisseur: "Fournisseur",
        montantTTC: "Montant TTC",
        montantHT: "Montant HT",
        status: "Statut"
      },
      nav: {
        paiementsAffect:"Paiements / BL",
        client:"Client",
        paiements:"Paiements",
        details:"Détails vente",
        etat:"Etat client",
        receptions:"Receptions",
        clientEtat:"Etat client",
        commercialsProgress:"Progression des commerciaux",
        commissionHistorique:"Historique des commissions",
        commissionPlans: "Plans de commission",
        siteReports: "Opérations chantier",
        commercialReports: "Opérations commerciaux",
        purchasesReports: "Rapports d'achats",
        expenses: "Dépenses",
        expensesCategories: "Catégories",
        listeReglementsFournisseur: "Paiements Fournisseur",
        commercials: "Commerciaux",
        supplierReports: "Opérations fournisseurs",
        mouvementStock: "Mouvement de Stock",
        lots: "Lots",
        "reglements": "Règlements",
        "listeReglements": "Paiements Clients",
        "rapportReglements": "Rapport des Règlements",
        customerReports: "Opérations clients",
        statistics: "Statistiques",
        accountingGroup: "Comptabilité",
        financeGroup: "Finance",
        accountingJournal: "Journal Comptable",
        generalLedger: "Grand Livre",
        balanceSheet: "Bilan Comptable",
        trialBalance: "Balance de Vérification",
        taxManagement: "Gestion des Taxes",
        cashFlow: "Trésorerie",
        checkManagement: "Gestion des Chèques",
        echeanceClient: "Échéance Client",
        echeanceFournisseur: "Échéance Fournisseur",
        bankReconciliation: "Réconciliation Bancaire",
        budget: "Budget",
        paymentCollection: "Encaissements",
        checkCollection: "Encaissement Chèques",
        cashCollection: "Encaissement Espèces",
        bankTransfers: "Virements Bancaires",
        transporteurs: "Transporteurs",
        unites: "Unités de mesure",
        articles: "Articles",
        categories: "Catégories",
        entrepots: "Entrepôts",
        reports: "Rapports",
        salesReports: "Rapports de vente",
        purchaseReports: "Rapports d'achat",
        expensesReports: "Rapports de dépenses",
        customerPayments: "Paiements clients",
        supplierPayments: "Paiements fournisseurs",
        expenses: "Dépenses",
        stakeholdersGroup: "Parties prenantes",
        paymentsGroup: "Paiements",
        settingsGroup: "Paramètres",
        purchases: "Achats",
        purchasesGroup: "Achats",
        salesGroup: "Ventes",
        purchaseOrders: "Bon de commande",
        documentsGroup: "Documents",
        inventoryGroup: "Inventaire",
        purchaseReturns: "Retours",
        clients: "Clients",
        suppliers: "Fournisseurs",
        order: "Bon de commande",
        bl: "Bon de livraison",
        devis: "Devis",
        facture: "Facture",
        dashboard: "Tableau de bord",
        products: "Produits",
        sales: "Point de vente",
        stock: "Gestion de Stock",
        barcodes: "Codes-barres",
        refund: "Retours",
        documentation: "Documentation",
        invoice: "Facture",
        livraison: "Bon de livraison",
        reception: "Bon de réception",
        payment: "Paiement",
        quote: "Devis",
        deliveryNote: "Bon de livraison",
        inventory: "Inventaire",
        profile: "Profil",
        signOut: "Déconnexion",
        modules: "Modules",
        backToModules: "Retour aux modules",
      },
      modules: {
        comingSoon: "À venir",
        comingsoon: "À venir",
        welcome: "Bienvenue dans {{businessName}}",
        selectModuleDescription: "Sélectionnez le module avec lequel vous souhaitez travailler",
        loggedInAs: "Connecté en tant que {{name}}",
        features: "Fonctionnalités",
        accessModule: "Accéder au module",
        totalModules: "Modules disponibles",
        availability: "Disponibilité",
        uptime: "Temps de fonctionnement",
        scalability: "Évolutivité",
        dashboard: {
          title: "Tableau de Bord",
          description: "Vue d'ensemble de votre activité",
          feature1: "Statistiques en temps réel",
          feature2: "Graphiques interactifs",
          feature3: "Indicateurs de performance"
        },
        inventory: {
          title: "Gestion des Stocks",
          description: "Gérez vos produits et inventaires",
          feature1: "Gestion des produits",
          feature2: "Suivi des stocks",
          feature3: "Codes-barres",
          feature4: "Mouvements de stock"
        },
        sales: {
          title: "Ventes",
          description: "Gérez vos ventes et clients",
          feature1: "Point de vente",
          feature2: "Factures et devis",
          feature3: "Gestion des clients",
          feature4: "Retours clients"
        },
        purchases: {
          title: "Achats",
          description: "Gérez vos achats et fournisseurs",
          feature1: "Commandes fournisseurs",
          feature2: "Réceptions",
          feature3: "Factures fournisseurs"
        },
        finance: {
          title: "Finance",
          description: "Gérez vos règlements et paiements",
          feature1: "Gestion des règlements",
          feature2: "Rapports financiers"
        },
        accounting: {
          title: "Comptabilité",
          description: "Comptabilité et reporting",
          feature1: "Grand livre",
          feature2: "Balance comptable",
          feature3: "Synthèse comptable"
        },
        reports: {
          title: "Rapports",
          description: "Analyses et statistiques",
          feature1: "Rapports de ventes",
          feature2: "Analyses clients"
        },
        settings: {
          title: "Paramètres",
          description: "Configuration du système",
          feature1: "Profil utilisateur"
        },
        crm: {
          title: "CRM",
          description: "Gérez vos clients et leurs interactions",
          feature1: "Gestion des contacts",
          feature2: "Suivi des opportunités",
          feature3: "Rapports sur les ventes"
        },
        hr: {
          title: "HR",
          description: "Gérez vos employés et leurs informations",
          feature1: "Gestion des employés",
          feature2: "Suivi des congés",
          feature3: "Rapports sur les performances"
        }
      },
      navigation: {
        modules: "Modules",
        backToModules: "Retour aux modules"
      },
      inventory: {
        confirmSubmit: "Confirmer la soumission",
        status: "Statut",
        allInventories: "Historique des inventaires",
        addProduct: "Ajouter un produit",
        productList: "Liste des produits",
        inventorySheet: "Fiche d'inventaire",
        pageTitle: "Inventaire",
        "codeArticle": "Code Produit",
        "description": "Produit",
        "stockTheorique": "Stock Theorique",
        "valeurUnitaire": "Prix",
        "stockReel": "Stock Reel",
        "valeurStockReel": "Valeur Stock",
        "ecartQuantite": "Ecart Quantite",
        "ecartValeur": "Ecart Valeur (DH)",
        "commentaire": "Commentaire",
        inventoryDate: "Date d'inventaire",
        currentStockValue: "Valeur Stock",
        responsible: "Responsable",
        totalItems: "Articles",
        submitted: "Inventaire soumis avec succès",
        submitSuccess: "Inventaire soumis avec succès",
        errorTitle: "Erreur",
        submitError: "Une erreur est survenue lors de la soumission de l'inventaire",
        loadInventory: "Charger l'inventaire",
        noInventories: "Aucun inventaire trouvé",
        selectInventory: "Sélectionnez...",
        confirmSubmit: "Confirmer la soumission",
        submitWarning: "Voulez-vous vraiment soumettre cet inventaire ?",
        confirmClose: "Confirmer la fermeture",
        closeWarning: "Voulez-vous vraiment fermer cet inventaire ?",
        closed: "Inventaire fermé avec succès",
        closeSuccess: "Inventaire fermé avec succès",
        closeError: "Une erreur est survenue lors de la fermeture de l'inventaire",
        closeInventory: "Fermer l'inventaire",
        newInventory: "Nouvel inventaire",
        closed: "Fermé",
        open: "Ouvert",
        closeCurrentInventory: "Fermer l'inventaire actuel",
        closeCurrentInventoryWarning: "Veuillez fermer l'inventaire actuel avant d'en ouvrir un nouveau.",
        submittedEdit: "Inventaire modifié avec succès",
        submitSuccessEdit: "Inventaire modifié avec succès",
      },

      "lot": {
        "title": "Gestion des Lots",
        "new": "Nouveau Lot",
        "edit": "Modifier le Lot",
        "details": "Détails du Lot",
        "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce lot ?",
        "deleteSuccess": "Lot supprimé avec succès",
        "deleteError": "Erreur lors de la suppression du lot",
        "statutUpdated": "Statut mis à jour avec succès",
        "statutUpdateError": "Erreur lors de la mise à jour du statut",
        "noLots": "Aucun lot trouvé",
        "searchPlaceholder": "Rechercher par numéro de lot, article...",
        "numeroLot": "Numéro de Lot",
        "article": "Article",
        "dateProduction": "Date de Production",
        "dateExpiration": "Date d'Expiration",
        "quantiteInitiale": "Quantité Initiale",
        "quantiteDisponible": "Quantité Disponible",
        "emplacement": "Emplacement",
        "statut": "Statut",
        "expiration": "Expiration",
        "mouvementStock": "Mouvement de Stock",
        "actif": "Actif",
        "epuise": "Épuisé",
        "retire": "Retiré",
        "nonConforme": "Non Conforme",
        "expired": "Expiré",
        "expiringSoon": "Expire dans {{days}} jours",
        "expiringIn": "Expire dans {{days}} jours",
        "expiring7Days": "Expire dans 7 jours",
        "expiring30Days": "Expire dans 30 jours",
        "valid": "Valide",
        "allStatuts": "Tous les statuts",
        "allExpirations": "Toutes les expirations",
        "totalLots": "Total des Lots",
        "lotsActifs": "Lots Actifs",
        "lotsExpirants": "Lots Expirants",
        "lotsEpuises": "Lots Épuisés",
        "alerteExpiration": "Attention ! Des lots arrivent à expiration",
        "etAutres": "et {{count}} autres",
        "marquerActif": "Marquer comme Actif",
        "marquerEpuise": "Marquer comme Épuisé",
        "marquerRetire": "Marquer comme Retiré",
        "marquerNonConforme": "Marquer comme Non Conforme",
        "numeroLot": "Numéro de Lot",
        "numeroLotRequired": "Le numéro de lot est obligatoire",
        "numeroLotPlaceholder": "Saisir le numéro de lot",
        "generate": "Générer",
        "article": "Article",
        "articleRequired": "L'article est obligatoire",
        "selectArticle": "Sélectionnez...",
        "selectArticleFirst": "Veuillez d'abord sélectionner un article",
        "unite": "Unité",
        "dateProduction": "Date de Production",
        "dateExpiration": "Date d'Expiration",
        "expirationAfterProduction": "La date d'expiration doit être postérieure à la date de production",
        "quantiteInitiale": "Quantité Initiale",
        "quantitePositive": "La quantité doit être positive",
        "quantiteRequired": "La quantité est obligatoire",
        "quantiteDisponible": "Quantité Disponible",
        "quantiteDisponibleMin": "La quantité disponible ne peut pas être négative",
        "quantiteDisponibleMax": "La quantité disponible ne peut pas dépasser la quantité initiale",
        "quantiteDisponibleRequired": "La quantité disponible est obligatoire",
        "emplacement": "Emplacement",
        "emplacementRequired": "L'emplacement est obligatoire",
        "emplacementPlaceholder": "Ex: DEPOT-A, MAGASIN-01",
        "emplacementHelp": "Indiquez l'emplacement physique du lot",
        "statut": "Statut",
        "statutRequired": "Le statut est obligatoire",
        "actif": "Actif",
        "epuise": "Épuisé",
        "retire": "Retiré",
        "nonConforme": "Non Conforme",
        "quantiteUtilisee": "Quantité Utilisée",
        "pourcentageUtilise": "Pourcentage Utilisé",
        "pourcentageDisponible": "Pourcentage Disponible",
        "createSuccess": "Lot créé avec succès",
        "updateSuccess": "Lot mis à jour avec succès",
        "informationsGenerales": "Informations Générales",
        "code": "Code",
        "informationsDates": "Informations Dates",
        "joursRestants": "Jours Restants",
        "expired": "Expiré",
        "expiredSince": "Expiré depuis {{days}} jours",
        "expiringSoon": "Expire dans {{days}} jours",
        "expiringIn": "Expire dans {{days}} jours",
        "daysRemaining": "{{days}} jours restants",
        "valid": "Valide",
        "informationsQuantites": "Informations Quantités",
        "utilisationLot": "Utilisation du Lot",
        "lotEpuise": "Ce lot est épuisé",
        "lotExpire": "Ce lot est expiré depuis {{days}} jours",
        "lotExpireBientot": "Ce lot expire dans {{days}} jours",
        "historiqueMouvements": "Historique des Mouvements",
        "aucunMouvement": "Aucun mouvement enregistré pour ce lot"
      },

      "mouvement": {
        "title": "Mouvements de Stock",
        "nouveau": "Nouveau Mouvement",
        "detailsMouvement": "Détails du Mouvement",
        "noMouvements": "Aucun mouvement de stock trouvé",
        "searchPlaceholder": "Rechercher par article, lot, référence...",
        "typeMouvement": "Type de Mouvement",
        "quantite": "Quantité",
        "nouvelleQuantite": "Nouvelle Quantité",
        "quantiteApres": "Quantité Après",
        "motif": "Motif",
        "motifPlaceholder": "Décrivez la raison de ce mouvement...",
        "referenceDocument": "Référence Document",
        "referenceDocumentPlaceholder": "Ex: BL-2024-001, FAC-2024-001...",
        "referenceDocumentHelp": "Référence du document associé (optionnel)",
        "date": "Date",
        "utilisateur": "Utilisateur",
        "reference": "Référence",

        "allTypes": "Tous les types",
        "entree": "Entrée",
        "sortie": "Sortie",
        "transfert": "Transfert",
        "ajustement": "Ajustement",
        "inventaire": "Inventaire",
        "perte": "Perte",
        "retourClient": "Retour Client",

        "types": {
          "entree": "Entrée",
          "sortie": "Sortie",
          "transfert": "Transfert",
          "ajustement": "Ajustement",
          "inventaire": "Inventaire"
        },

        "entreeDescription": "Ajouter du stock au lot",
        "sortieDescription": "Retirer du stock du lot",
        "transfertDescription": "Transférer vers un autre emplacement",
        "ajustementDescription": "Corriger la quantité",
        "inventaireDescription": "Mise à jour suite à inventaire",

        "quantiteMaximale": "Quantité maximale disponible",
        "quantiteActuelle": "Quantité actuelle",
        "quantiteNegative": "Attention: La quantité résultante sera négative",
        "quantiteMouvement": "Quantité du Mouvement",

        "resumeMouvement": "Résumé du Mouvement",
        "enregistrer": "Enregistrer le Mouvement",

        "typeRequired": "Le type de mouvement est requis",
        "quantiteRequired": "La quantité est requise",
        "quantitePositive": "La quantité doit être positive",
        "stockInsuffisant": "Stock insuffisant pour cette sortie",
        "motifRequired": "Le motif est requis",

        "createSuccess": "Mouvement enregistré avec succès",
        "createError": "Erreur lors de l'enregistrement du mouvement",

        "dateMouvement": "Date/Heure",
        "dateDebut": "Date de début",
        "dateFin": "Date de fin",
        "article": "Article",
        "codeArticle": "Code Article",
        "nomArticle": "Nom Article",
        "numeroLot": "Numéro de Lot",
        "numeroLotPlaceholder": "Ex: LOT-001",
        "quantite": "Quantité",
        "quantiteMouvement": "Quantité du Mouvement",
        "quantiteAvant": "Qté Avant",
        "quantiteApres": "Qté Après",
        "variation": "Variation",
        "prixUnitaire": "Prix Unitaire",
        "valorisation": "Valorisation",
        "motif": "Motif",
        "utilisateur": "Utilisateur",
        "utilisateurPlaceholder": "Nom d'utilisateur",
        "referenceDocument": "Référence",
        "referencePlaceholder": "Ex: CMD001, BL001",
        "emplacement": "Emplacement",

        "informationsGenerales": "Informations Générales",
        "informationsArticle": "Informations Article",
        "informationsQuantites": "Informations Quantités",
        "informationsFinancieres": "Informations Financières",
        sorties: "Sorties",
        "entrees": "Entrées",
        "transferts": "Transferts",
        "ajustements": "Ajustements",
      },

      refund: {
        searchPlaceholder: "Rechercher un remboursement...",
        number: "N° remboursement",
        date: "Date",
        total: "Total",
        pageTitle: "Historique des remboursements",
        newRefund: "Nouveau remboursement",
        viewHistory: "Historique des remboursements",
        pageTitle: "Remboursements",
        productList: "Liste des produits",
        items: "Articles à rembourser",
        quantity: "Quantité",
        price: "Prix unitaire",
        total: "Total",
        totalAmount: "Montant total",
        submit: "Valider le remboursement",
        successTitle: "Remboursement réussi",
        successMessage: "Le remboursement a été effectué avec succès",
        errorTitle: "Erreur",
        errorMessage: "Une erreur est survenue lors du remboursement",
        noProducts: "Aucun produit disponible",
        noItems: "Aucun article sélectionné",
        confirmDelete: "Voulez-vous supprimer cet article ?",
        receipt: {
          title: "Ticket de remboursement",
          refundNo: "N° remboursement",
          date: "Date",
          cashier: "Caissier",
          price: "Prix",
          quantity: "Qté",
          total: "Total",
          totalRefunded: "Total remboursé",
          thankYou: "Merci de votre visite",
          footer: "À bientôt !",
          print: "Imprimer le ticket"
        }
      },
      user: {
        greeting: "Bonjour",
        signOut: "Déconnexion",
        settings: "Paramètres",
        signedInAs: "Connecté en tant que",
        profile: "Profil",
      },
      language: {
        "french": "Français",
        "arabic": "Arabe"
      },
      profile: {
        activite: "Activité",
        languageUpdateSuccess: "Langue du ticket mise à jour avec succès",
        languageUpdateError: "Échec de la mise à jour de la langue du ticket",
        receiptLanguage: "Langue du ticket",
        pageTitle: "Paramètres du compte",
        businessName: "Nom de l'entreprise",
        address: "Adresse",
        telephone1: "Téléphone 1",
        telephone2: "Téléphone 2",
        cnss: "CNSS",
        email: "Email",
        newPassword: "Nouveau mot de passe",
        save: "Enregistrer",
        passwordChanged: "Mot de passe modifié avec succès",
        businessInfo: "Informations de l'entreprise",
        changePassword: "Changer le mot de passe",
        currentPassword: "Mot de passe actuel",
        confirmPassword: "Confirmer le mot de passe",
        changePasswordError: "Erreur lors de la modification du mot de passe",
        "companyInfoUpdateSuccess": "Informations de l'entreprise mises à jour avec succès",
        "companyInfoUpdateError": "Échec de la mise à jour des informations de l'entreprise",
        "identificationFiscale": "Identification Fiscale",
        "ice": "ICE",
        "patente": "Patente",
        "logo": "Logo",
        "model": "Modèle de Facture",
        "modelPreview": "Aperçu du Modèle de Facture",
        rc: "N° RC",
      },
      payment: {
        refDocument:"N° BL",
        refPaiement: "N° Paiement",
        amountRequiredForWalkIn: "Le montant est requis pour un client occasionnel",
        clientRequiredForWalkIn: "Client obligatoire",
        amountMustEqualTotal: "Le montant doit être égal au total",
        chequeAmount: "Montant du chèque",
        createError: "Erreur lors de la création du paiement",
        dueDate: "Date d'échéance",
        comment: "Commentaire",
        commentPlaceholder: "Ex: Paiement par carte",
        summary: "Résumé",
        alreadyPaid: "Déjà payé",
        currentPayment: "Paiement actuel",
        remainingAfterPayment: "Restant après le paiement",
        savePayment: "Enregistrer le paiement",
        remainingBeforePayment: "Restant avant le paiement",
        differentClientsError: "Les clients ne sont pas les mêmes",
        searchPayments: "Rechercher des paiements...",
        noAvailablePayments: "Pas de paiement disponibles",
        total: "Total",
        createInvoiceNote: "Note : Vous pouvez créer une facture à partir de ces paiements.",
        proceedToCreateInvoice: "Procéder à la création de la facture",
        createInvoiceFromPayments: "Créer une facture à partir des paiements",
        createInvoice: "Créer une facture",
        createInvoiceConfirmation: "Voulez-vous créer une facture à partir de ces paiements ?",
        status: "Statut",
        validated: "Validé",
        pending: "En attente",
        cashed: "Encaissé",
        canceled: "Annulé",
        rejected: "Rejeté",
        mode: "Mode de paiement",
        date: "Date de paiement",
        reference: "Référence",
        addPayment: "Ajouter un paiement",
        remainingAmount: "Montant restant",
        totalPaid: "Montant payé",
        payments: "Paiements",
        noPayments: "Aucun paiement trouvé",
        totalDue: "Montant dû (TTC)",
        pay: "Payer",
        partiel: "Partiel",
        nonPaye: "Non-Payer",
        title: "Paiement",
        method: "Mode de paiement",
        typePayment: "Type de paiement",
        cash: "Espèces",
        card: "Carte bancaire",
        amountPaid: "Montant payé",
        change: "Monnaie à rendre",
        remaind: "Reste à payé",
        virement: "Virement",
        cheque: "Chèque",
        espece: "Espèce",
        confirm: "Confirmer",
        cancel: "Annuler",
        title: "Paiement",
        newPayment: "Nouveau paiement",
        payNumber: "N° de paiement",
        paymentDate: "Date de paiement",
        amount: "Montant",
        paymentMode: "Mode de paiement",
        totalAmount: "Montant total",
        supplier: "Fournisseur",
        invoiceNumber: "N° Facture",
        actions: "Actions",
        noPaymentsFound: "Aucun paiement trouvé",
        checkNumber: "Numéro de chèque",
        enterCheckNumber: "Entrez le numéro de chèque",
        bank: "Banque",
        enterBankName: "Entrez le nom de la banque",
      },
      commercial: {
        "commissionPeriod": "Commission période",
        "onRevenue": "Sur chiffre d'affaires",
        "onMargin": "Sur marge",
        confirmDeleteTitle: "Confirmer la suppression",
        confirmDeleteText: "Êtes-vous sûr de vouloir supprimer ce commercial ?",
        onRevenue: "Sur le chiffre d'affaires",
        onMargin: "Sur la marge",
        status: "Statut",
        active: "Actif",
        inactive: "Inactif",
        commissionType: "Type de commission",
        percentage: "Pourcentage",
        fixed: "Fixe",
        commissionRate: "Taux de commission",
        monthlyTarget: "Objectif mensuel",
        notes: "Remarques",
        contractType: "Type de contrat",
        fullName: "Nom & Prénom",
        email: "Email",
        phone: "Téléphone",
        sector: "Secteur",
        hireDate: "Date d'embauche",
        list: "Commerciaux",
        new: "Nouveau Commercial",
        edit: "Modifier Commercial",
        noCommercials: "Aucun Commercial",
        searchPlaceholder: "Rechercher un commercial...",
        cdd: "CDD",
        cdi: "CDI",
        freelance: "Freelance"
      },
      dashboard: {
        startDate:"Date début",
        endDate:"Date fin",
        totalVentes:"Total des ventes",
        totalPaiements:"Total des paiements",
        valeurStock:"Valeur Stock",
        totalDepenses:"Total des dépenses",
        startMonth: "Mois de début",
        endMonth: "Mois de fin",
        totalBenefice: "Total Bénéfice",
        chiffreAffaire: "Chiffre d'Affaires",
        totalImpots: "Total des impôts",
        "totalSalesReturns": "Total des retours",
        "totalPurchaseReturns": "Total des retours d'achat",
        totalAllSales: "Total des ventes",
        totalDirectSales: "Ventes en Comptoire",
        customerInvoiceNotPayed: "Factures impayées",
        cutomerInvoicePayed: "Factures payées",
        invoiceNotPayed: "Factures non payées",
        numbreSupplierInvoices: "Total des achats",
        supplierInvoiceNotPayed: "Achats impayées",
        totalExpenses: "Total des dépenses",
        exportSuccess: "Exportation réussie",
        exportSuccessText: "Les ventes ont été exportées avec succès",
        exportLoading: "Exportation en cours...",
        exportLoadingText: "Veuillez patienter pendant l'exportation des ventes",
        exportSales: "Exporter les ventes",
        totalRefunds: "Total des remboursements",
        stockValue: "Valeur du stock",
        reports: "Rapports",
        today: "Aujourd'hui",
        week: "Semaine",
        month: "Mois",
        year: "Année",
        totalSales: "Ventes Totales",
        grossRevenue: "Chiffre d'Affaires",
        netIncome: "Bénéfice Net",
        lowStockAlert: "Alerte Stock Faible"
      },
      "commissionPlan": {
        "list": "Plans de commission",
        "new": "Nouveau plan",
        "edit": "Modifier plan",
        "period": "Période",
        "baseType": "Base de calcul",
        "objective": "Objectif",
        "baseRate": "Taux base (décimal)",
        "bonusRate": "Taux bonus (décimal)",
        "tiers": "Paliers progressifs",
        "addTier": "Ajouter palier",
        "threshold": "Seuil cumulé (HT)",
        "rate": "Taux (décimal)"
      },
      pagination: {
        showing: "Affichage de",
        of: "sur",
        itemsPerPage: "éléments par page"
      },
      common: {
        allWarehouses:"Tous",
        close: "Fermer",
        totals: "Totaux",
        update: "Mettre à jour",
        totals: "Totaux",
        print: "Imprimer",
        selectOption: "Sélectionner...",
        dateFrom: "Date de début",
        dateTo: "Date de fin",
        all: "Tous",
        exportPDF: "Exporter en PDF",
        success: "Succès",
        editInvoice: "Modifier la facture",
        "viewDetails": "Voir détails",
        search: "Rechercher",
        reset: "Réinitialiser",
        create: "Créer",
        "view": "Voir",
        "count": "Nombre",
        "exportExcel": "Exporter Excel",
        "clearFilters": "Effacer les filtres",
        download: "Télécharger",
        oui: "Oui",
        "filters": "Filtres",
        "export": "Exporter",
        non: "Non",
        updated: "Mis à jour avec succès", saving: "Enregistrement en cours...",
        return: "Retour",
        warning: "Attention",
        error: "Erreur",
        saveAndConfirm: "Enregistrer et confirmer",
        yes: "Oui",
        "close": "Fermer",
        no: "Non",
        ok: "OK",
        edit: "Modifier",
        select: "Sélectionner",
        saved: "Enregistré avec succès",
        add: "Ajouter",
        table: "Tableau",
        cards: "Carte",
        actions: "Actions",
        last7Days: "7 derniers jours",
        last30Days: "30 derniers jours",
        lastMonth: "Mois dernier",
        ytd: "Cette année",
        apply: "Appliquer",
        loading: "Chargement...",
        exportExcel: "Exporter Excel",
        save: "Enregistrer",
        cancel: "Annuler",
        confirm: "Confirmer",
        continue: "Continuer",
        loading: 'Chargement...',
        loadingData: 'Chargement des données...',
        showing: "Affichage de {{start}} à {{end}} sur {{total}} résultats (page {{currentPage}} de {{totalPages}})",
        yesSubmit: "Oui, soumettre",
        yesClose: "Oui, fermer",

      },
      stock: {
        uploadSuccess:"Importation réussi",
        upload:"Importer Excel",
        noStocks:"Aucun stock trouvé",
        title:"Gestion Stock",
        adjustmentSuccess: "Ajustement de stock enregistré avec succès",
        adjustmentError: "Erreur lors de l'ajustement de stock",
        adjustmentModalTitle: "Ajustement de Stock",
        adjust: "Ajuster",
        currentStock: "Stock système actuel",
        physicalQuantity: "Quantité physique (réelle)",
        difference: "Écart",
        adjustmentReason: "Raison d'ajustement",
        reasonInventory: "Écart d'inventaire",
        reasonBreakage: "Casse/Perte",
        reasonDonation: "Don/Échantillon",
        reasonError: "Erreur de saisie",
        noReference: "Aucune référence",
        noType: "Aucun type",
        receipt: "Nouvelle Réception",
        initStock: "Stock Initial",
        reference: "Source",
        type: "Type",
        noSupplier: "Aucun fournisseur disponible",
        enterQuantity: "Saisir la quantité...",
        finalPrices: "Prix de Vente",
        searchProducts: "Rechercher des produits...",
        finalPrice: "Prix Final",
        searchEntries: "Rechercher dans les entrées...",
        entries: "Entrées de Stock",
        addEntry: "Ajouter une Entrée",
        product: "Produit",
        buyingPrice: "Prix d'Achat",
        salePrice: "Prix de Vente",
        supplier: "Fournisseur",
        quantity: "Quantité",
        searchProduct: "Rechercher un produit...",
        finalSalePrices: "Prix de Vente Finaux",
        finalPrice: "Prix Final",
        addButton: "Ajouter au Stock",
        noEntries: "Aucune entrée de stock",
        noEntriesSubtext: "Ajoutez des entrées de stock en utilisant le formulaire ci-dessus",
        noPrices: "Aucun prix final disponible",
        noPricesSubtext: "Les prix finaux s'afficheront ici une fois les entrées de stock ajoutées",
        calculatedPrice: "Prix Calculé",
        userPrice: "Prix Manuel",
        pageTitle: "Gestion de Stock",
        selectProduct: "Sélectionnez...",
        searchProducts: "Rechercher un produit...",
        searchSupplier: "Rechercher un fournisseur...",
        selectSupplier: "Sélectionnez...",
        confirmSave: "Confirmer l'enregistrement",
        confirmSaveMessage: "Voulez-vous enregistrer cette entrée de stock ?",
        saved: "Entrée de stock enregistrée avec succès",
        entryDate: "Date d'entrée",
        stockEntriesFor: "Entrées de stock pour ",
        updateSuccess: "Mise à jour réussie",
        quantityUpdated: "La quantité a été mise à jour avec succès",
        updateError: "Erreur de mise à jour",
        updateErrorMessage: "Une erreur est survenue lors de la mise à jour de la quantité",
        deleteConfirmTitle: "Confirmer la suppression",
        deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer cette entrée de stock ?",
        deleteSuccess: "Suppression réussie",
        deleteSuccessMessage: "L'entrée de stock a été supprimée avec succès",
        deleteError: "Erreur de suppression",
        deleteErrorMessage: "Une erreur est survenue lors de la suppression",
        delete: "Supprimer"
      },
      supplier: {
        missingFields: "Veuillez remplir tous les champs obligatoires",
        nom: "Nom",
        prenom: "Prénom",
        ice: "ICE",
        rc: "RC",
        ife: "IF",
        telephone1: "Téléphone 1",
        telephone2: "Téléphone 2",
        entreprise: "Nom de fournisseur",
        savedSuccess: "Fournisseur enregistré avec succès",
        email: "Email",
        search: "Rechercher un fournisseur...",
        addNew: "Ajouter un nouveau fournisseur",
        description: "Fournisseur (Raison social)",
        contact: "Contact",
        phone: "Téléphone",
        address: "Adresse",
        addSuccess: "Fournisseur ajouté avec succès",
        new: "Nouveau fournisseur",
        code: "Code fournisseur",

      },
      category: {
        edit: "Modifier catégorie",
        new: "Nouvelle catégorie",
        list: "Catégories de produits",
        code: "Code",
        label: "Libellé",
        noCategories: "Aucune catégorie trouvée",
      },
      auth: {
        welcomeSignup: "Bienvenue sur MatjarPos",
        createAccount: "Créez votre compte pour commencer",
        businessInfo: "Informations de l'entreprise",
        personalInfo: "Informations personnelles",
        businessName: "Nom de l'entreprise",
        businessNamePlaceholder: "Entrez le nom de votre entreprise",
        address: "Adresse",
        addressPlaceholder: "Adresse complète de votre entreprise",
        phone: "Téléphone",
        phonePlaceholder: "+212 XXX-XXXXXX",
        email: "Email",
        emailPlaceholder: "exemple@domaine.com",
        username: "Nom d'utilisateur",
        usernamePlaceholder: "Choisissez un nom d'utilisateur",
        password: "Mot de passe",
        passwordPlaceholder: "Choisissez un mot de passe sécurisé",
        contactPreferences: "Préférences de contact",
        whatsapp: "WhatsApp",
        emailContact: "Email",
        sms: "SMS",
        credentialsInfo: "Après validation de votre compte, vos identifiants de connexion vous seront envoyés par email",
        signupButton: "Créer mon compte",
        haveAccount: "Déjà un compte ?",
        loginLink: "Se connecter",
        required: "Ce champ est obligatoire",
        invalidEmail: "Adresse email invalide",
        invalidPhone: "Numéro de téléphone invalide",
        passwordMin: "Le mot de passe doit contenir au moins 8 caractères",
        validationInfo: "Après vérification de votre compte,",
        credentialsVia: "vos accès vous seront envoyés via",
        selectContact: "veuillez sélectionner au moins un moyen de contact",
        welcomeBack: "Ravi de vous revoir",
        loginPrompt: "Connectez-vous à votre compte",
        username: "Nom d'utilisateur",
        usernamePlaceholder: "Entrez votre nom d'utilisateur",
        password: "Mot de passe",
        passwordPlaceholder: "Entrez votre mot de passe",
        loginButton: "Se connecter",
        noAccount: "Vous n'avez pas de compte ?",
        signupLink: "Créer un compte",
        invalidCredentials: "Nom d'utilisateur ou mot de passe incorrect",
        forgotPassword: "Mot de passe oublié ?",
        rememberMe: "Se souvenir de moi",
        logoutConfirmTitle: "Déconnexion",
        logoutConfirmText: "Êtes-vous sûr de vouloir vous déconnecter ?",
        logoutSuccess: "Vous avez été déconnecté avec succès",
        loginError: "Erreur de connexion",
      },
      validation: {
        required: "Ce champ est obligatoire",
        invalidEmail: "Adresse email invalide",
        invalidPhone: "Numéro de téléphone invalide",
        passwordMin: "Le mot de passe doit contenir au moins 8 caractères"
      },
      echeance: {
        reference: "Référence",
        dateEcheance: "Date d'échéance",
        dateReglement: "Date règlement",
        numeroCheque: "N°chèque",
        banque: "Banque",
        montantCheque: "Montant chèque",
        total: "Total"
      },
      caution: {
        reference: "Référence",
        dateEcheance: "Date d'échéance",
        dateReglement: "Date règlement",
        numeroCheque: "N°chèque",
        banque: "Banque",
        montantCheque: "Montant chèque",
        total: "Total"
      },
      client: {
        etatClient:"Etat client",
        chantiers: "Chantiers",
        echeances: "Échéances",
        cautions: "Cautions",
        viewDetails: "Voir les détails",
        echeancesDetails: "Détails des échéances",
        cautionsDetails: "Détails des cautions",
        noEcheances: "Aucune échéance trouvée",
        noCautions: "Aucune caution trouvée",
        soldeUtilise: "Solde utilisé",
        code: "Code",
        contact: "Contact",
        solde: "Solde",
        totalDebit: "Débit",
        totalCredit: "Crédit",
        nom: "Nom",
        list: "Liste des clients",
        ficheClient: "Fiche Client",
        newClient: "Nouveau Client",
        balance: "Solde",
        tele1: "Téléphone 1",
        tele2: "Téléphone 2",
        address: "Adresse",
        ice: "ICE",
        ville: "Ville",
      },
      barcode: {
        title: "Générateur de codes-barres",
        generate: "Générer les codes-barres",
        generated: "Codes-barres générés avec succès",
        error: "Erreur lors de la génération des codes-barres"
      },
      landing: {
        downloadDesktopApp: "Télécharger l'Application Bureau",
        hero: {
          title: "Gérez votre commerce en toute simplicité",
          subtitle: "Une solution complète de point de vente pour optimiser votre gestion commerciale",
          cta: "Commencer maintenant",
          login: "Déjà inscrit ? Connexion"
        },
        features: {
          title: "Nos Fonctionnalités",
          product: {
            title: "Gestion des produits",
            description: "Gérez facilement votre catalogue de produits, les prix et les descriptions"
          },
          stock: {
            title: "Gestion des stocks",
            description: "Suivez vos niveaux de stock en temps réel et gérez les approvisionnements"
          },
          sales: {
            title: "Gestion des ventes",
            description: "Interface de vente intuitive avec gestion des tickets et des paiements"
          },
          reports: {
            title: "Rapports détaillés",
            description: "Analysez vos performances avec des rapports complets et personnalisables"
          },
          barcode: {
            title: "Gestion des codes-barres",
            description: "Générez et imprimez des codes-barres pour tous vos produits"
          },
          refund: {
            title: "Gestion des remboursements",
            description: "Traitez facilement les remboursements et les retours"
          }
        },
        services: {
          title: "Services complémentaires",
          invoicing: {
            title: "Gestion des factures",
            description: "Créez et gérez facilement vos factures. Suivez vos paiements et gérez des rapports détaillés"
          },
          purchase: {
            title: "Gestion des achats",
            description: "Gérez vos commandes fournisseurs, suivez les livraisons et optimisez vos coûts d'approvisionnement"
          },
          inventory: {
            title: "Gestion des stocks",
            description: "Contrôlez votre inventaire en temps réel, gérez les alertes de stock et optimisez vos approvisionnements"
          }
        },
        contact: {
          title: "Demandez une démonstration",
          subtitle: "Contactez-nous pour découvrir comment MatjarPOS peut transformer votre business",
          whatsapp: "WhatsApp: +212 660 707 129",
          email: "contact@ideracloud.com"
        },
        footer: {
          copyright: "© 2025 MatjarPOS",
          developer: "Développé par IDERACLOUD"
        },
        benefits: {
          title: "Pourquoi Choisir MatjarPOS?",
          interface: "Interface Intuitive",
          interfaceDesc: "Une interface simple et facile à utiliser",
          support: "Support 24/7",
          supportDesc: "Une équipe dédiée à votre service",
          updates: "Mises à jour régulières",
          updatesDesc: "Des améliorations continues de vos fonctionnalités",
          security: "Données sécurisées",
          securityDesc: "Protection maximale de vos données"
        }
      },
      "customerReturns": {
        validateReturn: "Valider le retour",
        valide: "Validé",
        processRefund: "Rembourser",
        searchPlaceholder: "Rechercher par numéro de retour ou client",
        documentType: "Type de document",
        none: "Aucun",
        facture: "Facture",
        bl: "Bon de livraison",
        originalDeliveryNote: "Bon de livraison original",
        selectBL: "Sélectionnez le bon de livraison",
        addManualItem: "Ajouter un article manuellement",
        selectProduct: "Sélectionnez un produit",
        "title": "Retours Client",
        draft: "En attente",
        total: "Total",
        validated: "Validé",
        filterPlaceholder: "Filtrer par nom, numéro de retour ou statut",
        numero: "Numéro",
        confirmDelete: "Confirmer la suppression",
        comptabilise: "Comptabilisé",
        edit: "Modifier",
        date: "Date",
        client: "Client",
        generatePdf: "Imprimer",
        validatedSuccess: "Le retour client a été validé avec succès.",
        invoice: "Facture",
        reason: "Raison",
        brouillon: "En attente de validation",
        confirmValidate: "Confirmer la validation",
        confirmValidateMessage: "Êtes-vous sûr de vouloir valider ce retour ?",
        refundMode: "Type",
        montantTTC: "Montant TTC",
        montantHT: "Montant HT",
        montantTVA: "Montant TVA",
        status: "Statut",
        refunded: "Remboursé",
        noReturns: "Aucun retour client trouvé",
        new: "Nouveau",
        avoir: "AVOIR",
        remboursement: "REMBOURSEMENT",
        echange: "ÉCHANGE",
        "list": "Retours clients",
        "detail": {
          "title": "Détail du retour client",
          "back": "Retour",
          "edit": "Modifier",
          "validate": "Valider",
          "cancel": "Annuler",
          "refund": "Effectuer le remboursement",
          "generalInfo": "Informations générales",
          "clientAndInvoice": "Client et facture",
          "returnedItems": "Articles retournés",
          "fields": {
            "returnNumber": "Numéro de retour",
            "returnDate": "Date de retour",
            "status": "Statut",
            "refundMode": "Mode de remboursement",
            "client": "Client",
            "originalInvoice": "Facture d'origine",
            "reason": "Motif du retour"
          },
          "notFound": "Le retour client demandé n'existe pas ou a été supprimé."
        },
        "form": {
          alreadyAdded: "Déjà ajouté",
          clientTypes: {
            passenger: "Client passager"
          },
          "newTitle": "Nouveau",
          "editTitle": "Modifier un retour client",
          "generalInfo": "Informations générales",
          "fields": {
            "returnNumber": "Numéro de retour",
            "returnDate": "Date de retour",
            "refundMode": "Mode de remboursement",
            "client": "Client",
            "originalInvoice": "Facture d'origine",
            "reason": "Motif du retour"
          },
          "placeholders": {
            "returnNumber": "Généré automatiquement",
            "selectClient": "Sélectionner ...",
            "selectInvoice": "Sélectionner une facture",
            "reason": "Précisez le motif du retour"
          },
          "invoiceItems": "Articles de la facture",
          "returnedItems": "Articles retournés",
          "noItems": "Aucun article ajouté",
          "columns": {
            "item": "Article",
            "quantity": "Quantité",
            "unitPrice": "Prix UT",
            "unite": "Unité",
            "vat": "TVA",
            "total": "Total",
            "actions": "Actions",
            originalQte: "Quantité originale",
            returnedQte: "Quantité retournée",
          },
          "totals": {
            "totalHT": "Total HT",
            "totalVAT": "Total TVA",
            "totalTTC": "Total TTC"
          },
          "buttons": {
            "add": "Ajouter",
            "save": "Enregistrer",
            "cancel": "Annuler",
            "saving": "Enregistrement...",
            alreadyAdded: "Article déjà ajouté",
            itemAlreadyAdded: "Article déjà ajouté",
          },
          "validation": {
            "clientRequired": "Veuillez Sélectionner ...",
            "invoiceRequired": "Veuillez sélectionner une facture",
            "reasonRequired": "Veuillez préciser le motif du retour",
            "dateRequired": "Veuillez sélectionner une date",
            "itemsRequired": "Veuillez ajouter au moins une ligne de retour"
          }
        },

        "messages": {
          "createSuccess": "Retour client créé avec succès",
          "updateSuccess": "Retour client mis à jour avec succès",
          "validateSuccess": "Retour client validé avec succès",
          "cancelSuccess": "Retour client annulé avec succès",
          "deleteSuccess": "Retour client supprimé avec succès",
          "loadError": "Erreur lors du chargement des retours client",
          "saveError": "Erreur lors de l'enregistrement du retour client",
          "validateError": "Erreur lors de la validation du retour client",
          "cancelError": "Erreur lors de l'annulation du retour client",
          "deleteError": "Erreur lors de la suppression du retour client",
          "confirmValidate": "Êtes-vous sûr de vouloir valider ce retour client ?",
          "confirmCancel": "Êtes-vous sûr de vouloir annuler ce retour client ?",
          "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce retour client ?"
        }
      },
      expense: {
        searchPlaceholder: "Rechercher une dépense...",
        numero: "Numéro",
        dateOperation: "Date d'opération",
        montantPaye: "Montant payé",
        modeReglement: "Mode de règlement",
        total: "Total",
        comment: "Note",
        dateEcheance: "Date d'échéance",
        banque: "Banque",
        numeroCheque: "Numéro de chèque",
        selectCategory: "Sélectionner une catégorie...",
        list: "Dépenses",
        new: "Nouvelle dépense",
        edit: "Modifier",
        noExpenses: "Aucune dépense",
        selectCommercial: "Sélectionnez...",
        paymentMethod: {
          title: "Mode de paiement",
          placeholder: "Sélectionnez..."
        },
        category: {
          title: "Catégorie",
          list: "Catégories de dépenses",
          new: "Nouvelle catégorie",
          edit: "Modifier",
          code: "Code",
          label: "Libellé",
          noCategories: "Aucune catégorie de dépenses"
        },
        commercial: {
          title: "Commercial",
          list: "Commerciaux",
          new: "Nouveau commercial",
          edit: "Modifier",
          code: "Code",
          label: "Libellé",
          noCommercials: "Aucun commercial"
        }
      },

      // ...existing code...
    }
  },
  en: {
    translation: {
      receipt: {
        title: "SALES RECEIPT",
        store: "Supermarket 123",
        tel: "Tel: 123-456-7890",
        receiptNo: "Receipt #",
        date: "Date",
        cashier: "Cashier",
        item: "Item",
        quantity: "Qty",
        price: "Price",
        total: "Total",
        print: "Print PDF",
        close: "Close"
      },
      landing: {
        downloadDesktopApp: "Download Desktop App",
        benefits: {
          title: "Why Choose MatjarPOS?",
          interface: "Intuitive Interface",
          interfaceDesc: "A simple and easy to use interface",
          support: "24/7 Support",
          supportDesc: "A dedicated team at your service",
          updates: "Regular Updates",
          updatesDesc: "Continuous improvements of your features",
          security: "Secure Data",
          securityDesc: "Maximum protection of your data"
        },
        hero: {
          title: "Manage your business with ease",
          subtitle: "A complete point of sale solution to optimize your business management",
          cta: "Get Started",
          login: "Already registered? Login"
        },
        features: {
          title: "Our Features",
          product: {
            title: "Product Management",
            description: "Easily manage your product catalog, prices and descriptions"
          },
          stock: {
            title: "Stock Management",
            description: "Track your stock levels in real time and manage supplies"
          },
          sales: {
            title: "Sales Management",
            description: "Intuitive sales interface with ticket and payment management"
          },
          reports: {
            title: "Detailed Reports",
            description: "Analyze your performance with comprehensive and customizable reports"
          },
          barcode: {
            title: "Barcode Management",
            description: "Generate and print barcodes for all your products"
          },
          refund: {
            title: "Refund Management",
            description: "Process refunds and returns easily"
          }
        },
        services: {
          title: "Additional Services",
          invoicing: {
            title: "Invoice Management",
            description: "Create and manage your invoices easily. Track payments and generate detailed reports"
          },
          purchase: {
            title: "Purchase Management",
            description: "Manage supplier orders, track deliveries and optimize procurement costs"
          },
          inventory: {
            title: "Inventory Management",
            description: "Control your inventory in real time, manage stock alerts and optimize supplies"
          }
        },
        contact: {
          title: "Request a Demo",
          subtitle: "Contact us to discover how MatjarPOS can transform your business",
          whatsapp: "WhatsApp: +212 660 707 129",
          email: "contact@ideracloud.com"
        },
        footer: {
          copyright: "© {year} MatjarPOS",
          developer: "Developed with ❤ by IDERACLOUD"
        }
      }
    },
  },
  ar: {
    translation: {
      landing: {
        downloadDesktopApp: "تحميل تطبيق سطح المكتب",
        benefits: {
          title: "لماذا تختار MatjarPOS؟",
          interface: "واجهة سهلة الاستخدام",
          interfaceDesc: "واجهة بسيطة وسهلة الاستخدام",
          support: "دعم على مدار الساعة",
          supportDesc: "فريق متخصص في خدمتك",
          updates: "تحديثات منتظمة",
          updatesDesc: "تحسينات مستمرة للميزات",
          security: "بيانات آمنة",
          securityDesc: "حماية قصوى لبياناتك"
        },
        hero: {
          title: "أدر أعمالك بكل سهولة",
          subtitle: "حل نقاط البيع المتكامل لتحسين إدارة أعمالك",
          cta: "ابدأ الآن",
          login: "مسجل بالفعل؟ تسجيل الدخول"
        },
        features: {
          title: "مميزاتنا",
          product: {
            title: "إدارة المنتجات",
            description: "إدارة كتالوج المنتجات والأسعار والأوصاف بسهولة"
          },
          stock: {
            title: "إدارة المخزون",
            description: "تتبع مستويات المخزون في الوقت الفعلي وإدارة التوريدات"
          },
          sales: {
            title: "إدارة المبيعات",
            description: "واجهة مبيعات سهلة الاستخدام مع إدارة التذاكر والمدفوعات"
          },
          reports: {
            title: "تقارير مفصلة",
            description: "تحليل أدائك مع تقارير شاملة وقابلة للتخصيص"
          },
          barcode: {
            title: "إدارة الباركود",
            description: "إنشاء وطباعة الباركود لجميع منتجاتك"
          },
          refund: {
            title: "إدارة المرتجعات",
            description: "معالجة المرتجعات والاستردادات بسهولة"
          }
        },
        services: {
          title: "خدمات إضافية",
          invoicing: {
            title: "إدارة الفواتير",
            description: "إنشاء وإدارة الفواتير بسهولة. تتبع المدفوعات وإنشاء تقارير مفصلة"
          },
          purchase: {
            title: "إدارة المشتريات",
            description: "إدارة طلبات الموردين وتتبع التسليم وتحسين تكاليف الشراء"
          },
          inventory: {
            title: "إدارة المخزون",
            description: "التحكم في المخزون في الوقت الفعلي وإدارة تنبيهات المخزون وتحسين التوريدات"
          }
        },
        contact: {
          title: "اطلب عرضاً توضيحياً",
          subtitle: "اتصل بنا لمعرفة كيف يمكن لـ MatjarPOS تحويل أعمالك",
          whatsapp: "واتساب: +212 660 707 129",
          email: "contact@ideracloud.com"
        },
        footer: {
          copyright: "© {year} MatjarPOS",
          developer: "تم التطوير بواسطة IDERACLOUD ❤"
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "fr",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;